import * as React from 'react';
import { connect } from 'react-redux';
import Component from '../../AbstractComponent';
import Constants from '../../../Action/Constants';
import Time from '../../../Time/Time';
import TypeContainer from '../../../Entity/Entities/Charge/Type/TypeContainer';
import { ChargeInterface } from '../../../Entity/Entities/Charge/ChargeInterface';
import ChargeFactory from '../../../Entity/Factories/ChargeFactory';
import { PaymentInterface } from '../../../Entity/Entities/Payment/PaymentInterface';
import PaymentClassContainer from '../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer';
import { Timeline } from '../../Partials/Timeline/Timeline';
import EntityLaunchpanel from '../../Partials/Launchpanel/EntityLaunchpanel';
import { PromptDialog } from '../../Partials/Dialog/PromptDialog';
import { LeavePromptDialog } from '../../Partials/Dialog/LeavePromptDialog';
import CreateTaskDialog from '../../Partials/Dialog/CreateTaskDialog';
import { MiddlewareInterface } from '../../../Middleware/MiddlewareInterface';
import ChargeUpdateWillMount from '../../../Middleware/Middlewares/ChargeUpdateWillMount';
import { DeleteEntityPrompt } from '../../Partials/Dialog/DeleteEntityPrompt';
// import ChargeSection from "../../Partials/Charge/ChargeSection";
import Charge2Card from '../../Partials/Charge/Charge2Card';
import Payment2Card from '../../Partials/Payment/Payment2Card';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
// import Card from '@material-ui/core/Card';
import PreventPageLeave from '../../../Middleware/Middlewares/PreventPageLeave';
import ChargeClassContainer from '../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer';
import Store from '../../../Store/Store';
import { Property } from '../../../Entity/Entities/Property/Property';
import { Unit } from '../../../Entity/Entities/Unit/Unit';
import { Contract } from '../../../Entity/Entities/Contract/Contract';
import { Company } from '../../../Entity/Entities/Company/Company';
import { Person } from '../../../Entity/Entities/Person/Person';
import { Event } from '../../../Entity/Entities/Event/Event';
import { EventInterface } from '../../../Entity/Entities/Event/EventInterface';
import { PersonInterface } from '../../../Entity/Entities/Person/PersonInterface';
import { CompanyInterface } from '../../../Entity/Entities/Company/CompanyInterface';
import { PageTransition } from '../../Partials/Spinner/PageTransition';
import Formatter from '../../../Localization/Formatter';
import Payments2List from '../../Partials/Payment/Payments2List';
import PaymentTypeContainer from '../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer';
import { BankAccountInterface } from '../../../Entity/Entities/BankAccount/BankAccountInterface';
import { BankAccountCreate } from '../../Partials/Dialog/BankAccountCreate';
import { PropertyInterface } from '../../../Entity/Entities/Property/PropertyInterface';
import { UnitInterface } from '../../../Entity/Entities/Unit/UnitInterface';
import { ContractInterface } from '../../../Entity/Entities/Contract/ContractInterface';
import * as moment from 'moment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { SettleWithSavingsDialog } from '../../Partials/Dialog/SettleWithSavingsDialog';
import { UndoSettleWithSavingsDialog } from '../../Partials/Dialog/UndoSettleWithSavingsDialog';
import { QuickPaymentDialog } from '../../Partials/Dialog/QuickPaymentDialog';
import Memo from '../../Partials/Memo/Memo';
import { CoachCreateCreditInvoice } from '../../Partials/Dialog/CoachCreateCreditInvoice';
import { CoachNewSettleCharge } from '../../Partials/Dialog/CoachNewSettleCharge';
import PaymentCounterpartyDescriptionInfoForList from '../../Partials/Payment/PaymentCounterpartyDescriptionInfoForList';

class ChargeUpdate extends Component {
  protected charge: ChargeInterface;
  protected selectedPayment: PaymentInterface;
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_CHARGE_UPDATE_CLEAR;
  public noteField: null;

  protected middlewares: MiddlewareInterface[] = [
    ChargeUpdateWillMount,
    PreventPageLeave,
  ];

  public state = {
    events: [],
    linkedPayments: [],
    relatedPayments: [],
    settledCharges: [],
    chargeIdToUnsettle: null,
    renderDetails: true,
    isFetchingCharge: true,
    tasks: [],
    fetchingTasks: true,
    settledChargeIds: [],
    isEditableView: false,

    // payment
    paymentChoice: 'existing',
    amountForPayment: '',
    currencyIdForPayment: null,
    firstDateOfStatementPeriodForPayment: new Date(),
    dateOfThePayment: new Date(),
    typeIdForPayment: String(PaymentTypeContainer.pickIdFromLabel('Bank')),
    agencyBankAccountIdForPayment: null,
    counterpartyIbanForPayment: '',
    originalCounterpartyIban: null,
    paymentClassId: null,
    payerChoice: 'person',
    existingPayerChoice: 'person',
    selectedPersonForPayment: null,
    selectedCompanyForPayment: null,
    selectedPersonForExistingPayments: null,
    selectedCompanyForExistingPayments: null,
    descriptionForPayment: '',
    descriptionForPaymentIsManuallyChanged: false,
    directIndirectPayments: [],
    payerPayments: [],
    selectedDirectIndirectPaymentsRows: [],
    selectedPayerPaymentsRows: [],
    fetchedPayments: [],
    paymentIds: [],

    // charge
    chargeChoice: '',
    amountForCharge: '',
    invoiceDateForCharge: null,
    dueDateForCharge: null,
    invoiceNumberForCharge: '',
    vatForCharge: '',
    vatPercentageForCharge: '',
    isInvoice: false,
    amazonFolderName: '',
    attachments: [],
    currencyIdForCharge: null,
    chargeOwnerChoice: 'person',
    selectedPersonForCharge: null,
    selectedCompanyForCharge: null,
    selectedCounterpartyForCharge: null,
    selectedPersonForExistingCharges: null,
    selectedCompanyForExistingCharges: null,
    existingChargesPayerChoice: 'person',
    typeIdForCharge: null,
    selectedEntityForCharge: null,
    selectedEntityForExistingCharge: null,
    periodForCharge: 3, //todo: fix hardcoded value
    firstDateForCharge: null,
    dateOfPeriodForCharge: null,
    descriptionForCharge: '',
    showChargeOwnerChoice: true, //hack to rerender charge owner lookups
    directIndirectCharges: [],
    objectCharges: [],
    selectedDirectIndirectChargesRows: [],
    selectedObjectChargesRows: [],
    chargeIds: [],
    selectedCharge: null,
    isChargeFullyPaid: false,
    descriptionForChargeIsManuallyChanged: false,
    typeLabelForCharge: null,
    selectedEntityForChargeManuallyChanged: false,
    typeIdForChargeManuallyChanged: false,
    chargeClassId: null,
    financialStatement: null,
    chargeToAddNote: null,
    note: '',
    memoPopupOpen: false,
    isChargeUnrefundPopupOpen: false,
    isSent: false,
    relatedCharge: null,

    // popups
    isChooseExistingChargePopupOpen: false,
    isCreateBankAccountPopupOpen: false,
    changeCounterpdartyIbanPopupOpen: false,
    createExtraPaymentPopupOpen: false,
    additionalChargePopupOpen: false,
    isCreateChargeTypePopupOpen: false,
    isChargeUnSettlePopupOpen: false,
    considerPaidProcess: false,
    considerPaidProcessDescription: '',
    isWithdrawalForChargePopupOpen: false,
    isPostProcessWithdrawalDialogOpen: false,
    cannotDeleteSavingsChargeDialog: false,
    isDepositToOwnerSavingsPopupOpen: false,
    isDepositToAgencySavingsPopupOpen: false,
    depositToOwnerSavingsProcess: false,
    depositToAgencySavingsProcess: false,
    isChargeSettleWithSavingsPopupOpen: false,
    settleSavingScenarioMessage: '',
    isPayChargePopupOpen: false,
    payChargeProcess: false,
    isNewTaskPopupOpen: false,
    isCreatePdfPopupOpen: false,
    isSetInvoicePopupOpen: false,
    isNegativeAmountPopupOpen: false,

    //
    isSaving: false,
    hasModifiedData: false,
    additionalSectionHasModifiedData: false,
    openLeavePrompt: false,
    nextPath: '',
    counterpartyIbanForPaymentWasChanged: false,
    counterpartyIbanForPaymentIsManuallyChanged: false,
    ibanUsedForEntity: null,
    ibanWasChanged: false,
    shouldSettleTheDifference: false,
    shouldCreateExtraPayment: false,
    skipCreateExtraPayment: false,
    detailsForExtraPaymentPopup: {},
    shouldCreateAdditionalCharge: false,
    skipCreateAdditionalCharge: false,
    detailsForAdditionalChargePopup: {
      additionalChargeInformationText: '',
    },
    additionalChargeTypeId: null,
    additionalChargeDescription: null,
    chargeTypeSelectField: 'Receivable',
    isItemSelected: null,
    chargeChoiceIsManuallyChanged: false,
    chargeToDelete: null,
    typeNameForPayment: 'Bank',
    chargeToUnlink: null,
    anchorEl: null,
    isSettle: false,
    hasSettlementType: false,
    selectedPayment: null,
    fetchingEvents: true,
    isPaymentFullyUsedPopupOpen: false,
    isMainChargeUnlinkPopupOpen: false,
    isChargeRemovePopupOpen: false,
    paymentToSettle: null,
    charge: null,
    descriptionManuallyChanged: false,
    chargeDescriptionAutomatic: false,
    typeDescriptionSecondParametr: '',
    checkTypeDescriptionPeriod: false,
    type: null,
    chargeTypeObj: null,
    paymentToDelete: null,
    showPayerChoice: false,
    selectedEntity: null,
    entityIsNotValid: false,
    isPaymentUnlinkPopupOpen: false,
    isPaymentRemovePopupOpen: false,
    anchorElCharge: null,
    hasSavingsType: false,
    linkedToSavingsPayment: false,
    hasPayoutType: false,
    chargeSectionIsSummaryView: true,
    paymentIdForDetailsPresentation: null,
    settledChargeIdForDetailsPresentation: null,
    showLaunchPanel: true,
    paymentDateQuickOption: new Date(),
    financialStatementPeriodMinDate: null,
    isUndoSavingsPopupOpen: false,
    isErrorLaunchPanelOpen: false,
    isSettleChargePopupOpen: false,
    createCreditProcessAmount: '',
    createCreditProcessDescription: '',
    isSetPaidDirectlyToOwnerPopupOpen: false,
    isCoachCreateCreditInvoiceOpen: false,
    isCoachSettleChargeOpen: false,
    chargeSearchString: '',
    chargeSearchInProgress: false,
    paymentSearchString: '',
    paymentSearchInProgress: false,
    isUndoCreditPopupOpen: false,
    showAllFields: false,
    isUndoWithdrawalPopupOpen: false,
    isUndoDepositPopupOpen: false,
    chargeToUncredit: null,
    // showHintBox: false
    lng: this.props.app?.settings?.agency?.defaultLocale?.iso,
  };

  constructor(public props) {
    super(props);

    this.createPayment = this.createPayment.bind(this);
    this.closePrompt = this.closePrompt.bind(this);
    this.delete = this.delete.bind(this);
  }

  public componentWillUnmount() {
    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);
    if (id === nextProps?.component?.charge?.id) {
      this.setState({
        charge: nextProps?.component?.charge,
        attachments: nextProps?.component?.charge?.attachments,
      });
    }

    if (
      !this.props?.charges?.requestsOutdated &&
      nextProps?.charges?.requestsOutdated
    ) {
      this.initializePage(id);
    }

    if (prevId !== id) {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_CLEAR,
      });
      this.initializePage(id);
    }
  }

  public setDescriptionByTypeAndDate = (charge) => {
    return `${Formatter.checkTranslationType(
      this.trans(charge?.type?.label, {}, Store.getConfigurator().getState().app.settings.agency?.defaultLanguage?.iso, charge?.type?.system),
      charge?.type?.label,
      charge?.type?.system
    )}, ${Formatter.monthFullFormatDate(charge.firstDate)}`.replace(
      /\s{2,}/g,
      ' '
    );
  };

  public setDescriptionChargeDefault = (charge) => {
    return charge.description.split(', ');
  };

  public checkTypeDescription = (charge, descriptionChargeDefault) => {
    return (
      Formatter.checkTranslationType(
        this.trans(charge?.type?.label, {}, Store.getConfigurator().getState().app.settings.agency?.defaultLanguage?.iso, charge?.type?.system),
        charge?.type?.label,
        charge?.type?.system
      ) === descriptionChargeDefault[0]
    );
  };

  public checkMounthDescription = (charge, descriptionChargeDefault) => {
    return (
      Formatter.monthFullFormatDate(charge.firstDate) ===
        descriptionChargeDefault[1] ||
      moment(charge.firstDate).format('MMM') === descriptionChargeDefault[1]
    );
  };

  public updateMainCharge = (charge) => {
    const chargeClassId: number = charge.chargeClass?.id;
    const descriptionByTypeAndDate = this.setDescriptionByTypeAndDate(charge);

    let descriptionChargeDefault = this.setDescriptionChargeDefault(charge);
    let checkTypeDescription = this.checkTypeDescription(
      charge,
      descriptionChargeDefault
    );
    let checkMounthDescription = this.checkMounthDescription(
      charge,
      descriptionChargeDefault
    );
    let typeDescriptionPeriod = descriptionChargeDefault[1];

    const agencyBankAccounts: BankAccountInterface[] =
      this.getAgencyBankAccounts();

    const defaultBankAccount: BankAccountInterface = agencyBankAccounts.find(
      (bankAccount) => {
        return bankAccount.isDefault === true;
      }
    );

    let agencyBankAccountId;

    if (!!defaultBankAccount) {
      agencyBankAccountId = !!defaultBankAccount ? defaultBankAccount.id : null;
    } else {
      agencyBankAccountId = !!agencyBankAccounts[0]
        ? agencyBankAccounts[0].id
        : null;
    }

    const isSettle = charge && charge.isSettle;
    const hasSettlementType = charge && charge.type && charge.hasSettlementType;
    const hasSavingsType = charge && charge.hasSavingsType;
    const hasPayoutType = charge && charge.hasPayoutType;

    return this.setState(
      {
        charge: charge,
        descriptionForCharge: charge.description,
        amountForCharge: Formatter.simpleFormatNumber(charge.amount),
        invoiceDateForCharge: charge.invoiceDate,
        dueDateForCharge: charge.dueDate,
        invoiceNumberForCharge: charge.invoiceNumber,
        vatForCharge: Formatter.simpleFormatNumber(charge.vat),
        vatPercentageForCharge: isNaN(
          Math.round((charge.vat / (charge.amount - charge.vat)) * 100)
        )
          ? 0
          : Formatter.simpleFormatNumber(
              Math.round((charge.vat / (charge.amount - charge.vat)) * 100),
              false,
              false
            ),
        isInvoice: charge.isInvoice,
        amazonFolderName: charge.amazonFolderName,
        attachments: charge.attachments,
        currencyIdForCharge: charge.currency.getCurrencyId(),
        typeIdForCharge: charge.type.id,
        firstDateForCharge: charge.firstDate,
        dateOfPeriodForCharge: charge.dateOfPeriod,
        periodForCharge: charge.period.id,
        openLeavePrompt: false,
        selectedPersonForCharge: charge.contact,
        selectedCompanyForCharge: charge.company,
        selectedCounterpartyForCharge: charge?.counterparty,
        selectedEntityForCharge: charge.relatedEntity,
        entityIsNotValid: false,
        isSaving: false,
        chargeOwnerChoice: charge.companyId ? 'company' : 'person',
        isPaymentUnlinkPopupOpen: false,
        isPaymentRemovePopupOpen: false,
        paymentToDelete: null,
        chargeTypeSelectField: null,
        anchorEl: null,
        chargeDescriptionAutomatic:

          charge.description === descriptionByTypeAndDate ||
          checkTypeDescription ||
          checkMounthDescription
            ? true
            : false,
        descriptionManuallyChanged: false,
        chargeTypeObj: charge.type,
        checkTypeDescriptionPeriod:
          !checkMounthDescription && checkTypeDescription ? true : false,
        typeDescriptionSecondParametr:
          typeDescriptionPeriod && typeDescriptionPeriod,
        isFetchingCharge: false,
        // renderDetails: false,
        showChargeOwnerChoice: true,
        isSettle: isSettle,
        hasSettlementType: hasSettlementType,
        chargeClassId: chargeClassId,
        financialStatement: charge.financialStatement,
        hasSavingsType: hasSavingsType,
        note: charge.note,
        hasPayoutType: hasPayoutType,
        isSent: charge?.isSent,

        // payment
        paymentChoice: 'existing',
        amountForPayment: Formatter.simpleFormatNumber(charge.amountRemaining),
        currencyIdForPayment:
          this.props.app.settings.user.currency.getCurrencyId(),
        firstDateOfStatementPeriodForPayment: charge.firstDate,
        dateOfThePayment: charge.firstDate,
        typeIdForPayment: String(PaymentTypeContainer.pickIdFromLabel('Bank')),
        typeNameForPayment: 'Bank',
        agencyBankAccountIdForPayment: agencyBankAccountId,
        counterpartyIbanForPayment: '',
        originalCounterpartyIban: '',
        paymentClassId: String(chargeClassId),
        payerChoice: charge.company ? 'company' : 'person',
        showPayerChoice: true,
        existingPayerChoice: 'person',
        selectedPersonForPayment: charge.contact,
        selectedCompanyForPayment: charge.company,
        selectedPersonForExistingPayments: null,
        selectedCompanyForExistingPayments: null,
        descriptionForPayment: '',
        descriptionForPaymentIsManuallyChanged: false,
        directIndirectPayments: [],
        payerPayments: [],
        selectedDirectIndirectPaymentsRows: [],
        selectedPayerPaymentsRows: [],
        fetchedPayments: [],
        paymentIds: [],
        counterpartyIbanForPaymentIsManuallyChanged: false,
        isCreateBankAccountPopupOpen: false,

        chargeSectionIsSummaryView: true,
        paymentIdForDetailsPresentation: null,
        settledChargeIdForDetailsPresentation: null,
        chargeIdToUnsettle: null,
        considerPaidProcessDescription: this.trans(
          'page/chargeupdate-preprocess/considerpay-dummydescription'
        ),
        // showLaunchPanel: false,
        paymentDateQuickOption: new Date(),
        financialStatementPeriodMinDate: null,
        isChargeUnrefundPopupOpen: false,
        isUndoSavingsPopupOpen: false,
        isErrorLaunchPanelOpen: false,
        createCreditProcessAmount: Formatter.simpleFormatNumber(
          charge.amountRemaining
        ),
        createCreditProcessDescription: this.trans(
          'page/chargeupdate-preprocess/credit-defaultdescription'
        ),
        isSetPaidDirectlyToOwnerPopupOpen: false,
        chargeSearchString: '',
        chargeSearchInProgress: false,
        paymentSearchString: '',
        paymentSearchInProgress: false,
        isUndoCreditPopupOpen: false,
        isNegativeAmountPopupOpen: false,
      },
      () => this.initializePage(this.state.charge.id)
    );
  };

  public initializePage = (id: number) => {
    this.setState({
      isSaving: true,
    });
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE,
      payload: {
        chargeId: id,
      },
      onSuccess: (charge: ChargeInterface) => {
        if (!charge) {
          return this.redirectBack();
        }

        this.fetchEntityEvents(id);
        const descriptionByTypeAndDate =
          this.setDescriptionByTypeAndDate(charge);

        let descriptionChargeDefault = this.setDescriptionChargeDefault(charge);
        let checkTypeDescription = this.checkTypeDescription(
          charge,
          descriptionChargeDefault
        );
        let checkMounthDescription = this.checkMounthDescription(
          charge,
          descriptionChargeDefault
        );
        let typeDescriptionPeriod = descriptionChargeDefault[1];

        const agencyBankAccounts: BankAccountInterface[] =
          this.getAgencyBankAccounts();

        const defaultBankAccount: BankAccountInterface =
          agencyBankAccounts.find((bankAccount) => {
            return bankAccount.isDefault === true;
          });

        let agencyBankAccountId;

        if (!!defaultBankAccount) {
          agencyBankAccountId = !!defaultBankAccount
            ? defaultBankAccount.id
            : null;
        } else {
          agencyBankAccountId = !!agencyBankAccounts[0]
            ? agencyBankAccounts[0].id
            : null;
        }

        const chargeClassId: number = charge.chargeClass?.id;

        const isSettle = charge && charge.isSettle;
        const hasSettlementType =
          charge && charge.type && charge.hasSettlementType;
        const hasSavingsType = charge && charge.hasSavingsType;
        const hasPayoutType = charge && charge.hasPayoutType;

        const linkedPayments: PaymentInterface[] = [
          ...charge.linkedPayments,
        ].filter((payment: PaymentInterface) => !!payment && !payment.removed);
        const relatedPayments: PaymentInterface[] = [
          ...charge.relatedPayments,
        ].filter((payment: PaymentInterface) => !!payment && !payment.removed);
        const settlementPayments: PaymentInterface[] = linkedPayments.filter(
          (payment: PaymentInterface) => payment.hasSettlementType
        );
        const settledCharges = [];
        const settledChargeIds = [];

        if (charge.linkedChargeId) {
          this.props.dispatch({
            type: Constants.GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE,
            payload: {
              chargeId: charge.linkedChargeId,
            },
            onSuccess: (charge: ChargeInterface) => {
              this.setState({
                relatedCharge: charge,
              });
            },
          });
        }

        settlementPayments.forEach((payment: PaymentInterface) => {
          const settledChargeId = payment.chargeIds.find(
            (id) => id !== charge?.id
          );
          settledChargeIds.push(settledChargeId);

          this.props.dispatch({
            type: Constants.GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE,
            payload: {
              chargeId: settledChargeId,
            },
            onSuccess: (charge: ChargeInterface) => {
              const settledCharges = [...this.state.settledCharges];
              const settledCharge = settledCharges.find(
                (chargeObject) => chargeObject?.charge?.id === charge?.id
              );

              if (!settledCharge) {
                settledCharges.unshift({
                  charge: charge,
                });
              }

              this.setState({
                settledCharges: settledCharges,
              });
            },
          });
        });

        this.setState({
          settledChargeIds,
        });

        let state: any = {
          charge: charge,
          linkedPayments: [...linkedPayments],
          relatedPayments: [...relatedPayments],
          settledCharges: [...settledCharges],
          // CASA-7824
          linkedToSavingsPayment: [...linkedPayments].some(
            (payment: PaymentInterface) =>
              payment?.paymentType?.id ===
              PaymentTypeContainer.pickIdFromLabel('Savings_account')
          ),
          descriptionForCharge: charge.description,
          amountForCharge: Formatter.simpleFormatNumber(charge.amount),
          invoiceDateForCharge: charge.invoiceDate,
          dueDateForCharge: charge.dueDate,
          invoiceNumberForCharge: charge.invoiceNumber,
          vatForCharge: Formatter.simpleFormatNumber(charge.vat),
          vatPercentageForCharge: isNaN(
            Math.round((charge.vat / (charge.amount - charge.vat)) * 100)
          )
            ? 0
            : Formatter.simpleFormatNumber(
                Math.round((charge.vat / (charge.amount - charge.vat)) * 100),
                false,
                false
              ),
          isInvoice: charge.isInvoice,
          amazonFolderName: charge.amazonFolderName,
          attachments: charge.attachments,
          currencyIdForCharge: charge.currency.getCurrencyId(),
          typeIdForCharge: charge.type.id,
          firstDateForCharge: charge.firstDate,
          dateOfPeriodForCharge: charge.dateOfPeriod,
          periodForCharge: charge.period.id,
          openLeavePrompt: false,
          selectedPersonForCharge: charge.contact,
          selectedCompanyForCharge: charge.company,
          selectedCounterpartyForCharge: charge?.counterparty,
          selectedEntityForCharge: charge.relatedEntity,
          entityIsNotValid: false,
          isSaving: false,
          chargeOwnerChoice: charge.companyId ? 'company' : 'person',
          isPaymentUnlinkPopupOpen: false,
          isPaymentRemovePopupOpen: false,
          paymentToDelete: null,
          chargeTypeSelectField: null,
          anchorEl: null,
          chargeDescriptionAutomatic:

            charge.description === descriptionByTypeAndDate ||
            checkTypeDescription ||
            checkMounthDescription
              ? true
              : false,
          descriptionManuallyChanged: false,
          chargeTypeObj: charge.type,
          checkTypeDescriptionPeriod:
            !checkMounthDescription && checkTypeDescription ? true : false,
          typeDescriptionSecondParametr:
            typeDescriptionPeriod && typeDescriptionPeriod,
          isFetchingCharge: false,
          renderDetails: false,
          showChargeOwnerChoice: true,
          isSettle: isSettle,
          hasSettlementType: hasSettlementType,
          chargeClassId: chargeClassId,
          financialStatement: charge.financialStatement,
          hasSavingsType: hasSavingsType,
          note: charge.note,
          hasPayoutType: hasPayoutType,
          isSent: charge?.isSent,
          isEditableView: false,

          // payment
          paymentChoice: 'existing',
          amountForPayment: Formatter.simpleFormatNumber(
            charge.amountRemaining
          ),
          currencyIdForPayment:
            this.props.app.settings.user.currency.getCurrencyId(),
          firstDateOfStatementPeriodForPayment: charge.firstDate,
          dateOfThePayment: charge.firstDate,
          typeIdForPayment: String(
            PaymentTypeContainer.pickIdFromLabel('Bank')
          ),
          typeNameForPayment: 'Bank',
          agencyBankAccountIdForPayment: agencyBankAccountId,
          counterpartyIbanForPayment: '',
          originalCounterpartyIban: '',
          paymentClassId: String(chargeClassId),
          payerChoice: charge.company ? 'company' : 'person',
          showPayerChoice: true,
          existingPayerChoice: 'person',
          selectedPersonForPayment: charge.contact,
          selectedCompanyForPayment: charge.company,
          selectedPersonForExistingPayments: null,
          selectedCompanyForExistingPayments: null,
          descriptionForPayment: '',
          descriptionForPaymentIsManuallyChanged: false,
          directIndirectPayments: [],
          payerPayments: [],
          selectedDirectIndirectPaymentsRows: [],
          selectedPayerPaymentsRows: [],
          fetchedPayments: [],
          paymentIds: [],
          counterpartyIbanForPaymentIsManuallyChanged: false,
          isCreateBankAccountPopupOpen: false,

          chargeSectionIsSummaryView: true,
          paymentIdForDetailsPresentation: null,
          settledChargeIdForDetailsPresentation: null,
          chargeIdToUnsettle: null,
          considerPaidProcessDescription: this.trans(
            'page/chargeupdate-preprocess/considerpay-dummydescription'
          ),
          showLaunchPanel: false,
          paymentDateQuickOption: new Date(),
          financialStatementPeriodMinDate: null,
          isChargeUnrefundPopupOpen: false,
          isUndoSavingsPopupOpen: false,
          isErrorLaunchPanelOpen: false,
          createCreditProcessAmount: Formatter.simpleFormatNumber(
            charge.amountRemaining
          ),
          createCreditProcessDescription: this.trans(
            'page/chargeupdate-preprocess/credit-defaultdescription'
          ),
          isSetPaidDirectlyToOwnerPopupOpen: false,
          chargeSearchString: '',
          chargeSearchInProgress: false,
          paymentSearchString: '',
          paymentSearchInProgress: false,
          isUndoCreditPopupOpen: false,
          isUndoWithdrawalPopupOpen: false,
          isUndoDepositPopupOpen: false,
          settings: Store.getConfigurator().getState().app.settings.user,
          isNegativeAmountPopupOpen: false,
        };

        if (
          Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length >
          0
        ) {
          const createdPerson =
            this.props.app?.savedDataBeforeRedirecting?.createdPerson;
          const createdCompany =
            this.props.app?.savedDataBeforeRedirecting?.createdCompany;

          state = {
            ...state,
            ...this.props.app?.savedDataBeforeRedirecting?.[
              `chargeUpdate-${charge?.id}-DataToBeSaved`
            ],
            chargeOwnerChoice: createdCompany ? 'company' : 'person',
            payerChoice: createdCompany ? 'company' : 'person',
          };

          if (!!createdPerson) {
            state.selectedPersonForCharge = createdPerson;
            state.selectedPersonForPayment = createdPerson;
            state.hasModifiedData = true;
          }

          if (!!createdCompany) {
            state.selectedCompanyForCharge = createdCompany;
            state.selectedCompanyForPayment = createdCompany;
            state.hasModifiedData = true;
          }
        }

        this.setState(
          {
            ...state,
          },
          () => {
            this.setState({ renderDetails: true, showLaunchPanel: true });
            if (charge?.ownerId) {
              this.getStatementPeriodForCharge();
            }

            this.fetchDirectIndirectPayments(true);
            this.fetchExistingCharges();

            this.props.dispatch({
              type: Constants.CHARGE_DETAILS_UPDATE_ACTION,
              payload: {
                action: '',
              },
            });
          }
        );
      },
      onError: () => {
        return this.redirectBack();
      },
    });
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  public updateChargeSearchString = (chargeSearchString: string) => {
    this.setState(
      {
        chargeSearchString: chargeSearchString,
      },
      this.fetchExistingCharges
    );
  };

  public updatePaymentSearchString = (paymentSearchString: string) => {
    this.setState(
      {
        paymentSearchString: paymentSearchString,
      },
      this.fetchPayerPayments
    );
  };

  public changeChargeSentStatus = (charge, callback?) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CHANGE_SENT_START,
        payload: {
          chargeId: charge?.id,
          isSent: !this.state.isSent,
        },
        onSuccess: (charge) => {
          this.setState(
            {
              isSent: charge?.isSent,
              isSaving: false,
            },
            () => {
              if (typeof callback === 'function') {
                callback();
              }
            }
          );
        },
        onError: () => {
          this.setState({
            isSaving: false,
          });
        },
      });
    });
  };

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        chargeId: entityId,
      },
      onSuccess: (data) => {
        const chargeEvents: EventInterface[] = data.events.filter(
          (event: EventInterface) => !event.removed
        );
        this.setState({
          events: [...chargeEvents],
          fetchingEvents: false,
        });
      },
    });
  };

  public linkNewPaymentWithCharge = (charge?: ChargeInterface): void => {
    const payment: any = {
      amount: parseFloat(
        parseFloat(
          String(
            Formatter.deleteExtraSpace(this.state.amountForPayment)
          ).replace(',', '.')
        ).toFixed(2)
      ),
      amountRemaining: parseFloat(
        (
          100 *
          parseFloat(
            String(
              Formatter.deleteExtraSpace(this.state.amountForPayment)
            ).replace(',', '.')
          )
        ).toFixed(2)
      ),
      currencyId: this.state.currencyIdForPayment,
      currency: this.state.currencyIdForPayment,
      firstDateOfStatementPeriod: Time.formatOrNull(
        this.state.firstDateOfStatementPeriodForPayment
      ),
      dateOfThePayment: Time.formatOrNull(this.state.dateOfThePayment),
      paymentTypeId: Number(this.state.typeIdForPayment),
      agencyBankAccount:
        this.state.typeNameForPayment === 'Bank'
          ? this.state.agencyBankAccountIdForPayment
          : null,
      paymentClassId: Number(this.state.paymentClassId),
      description: this.state.descriptionForPayment,
    };

    if (!!charge && charge.chargeClass.id !== payment.paymentClassId) {
      this.setState({ hasModifiedData: true, isSaving: false });

      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans(
            'preprocess/cannotpaycharge-info/differentclasses'
          ),
          type: 'warning',
        },
      });
    }

    if (!!charge) {
      payment.chargeIds = [charge.id];
    }

    if (this.state.selectedPersonForPayment?.id) {
      payment.contactId = this.state.selectedPersonForPayment?.id;
    }

    if (this.state.selectedCompanyForPayment?.id) {
      payment.companyId = this.state.selectedCompanyForPayment?.id;
    }

    if (
      Number(this.state.typeIdForPayment) ===
      PaymentTypeContainer.pickIdFromLabel('Bank')
    ) {
      const iban = this.state.counterpartyIbanForPayment;

      if (iban) {
        const company: CompanyInterface = this.props.app.companies.find(
          (company: CompanyInterface) =>
            company?.mainBankAccountId === this.state.counterpartyIbanForPayment
        );
        const person: PersonInterface = this.props.app.persons.find(
          (person: PersonInterface) =>
            person?.mainBankAccountId === this.state.counterpartyIbanForPayment
        );

        if (
          (!!person &&
            !!this.state.selectedPersonForPayment &&
            person.id !== this.state.selectedPersonForPayment.id) ||
          !this.state.selectedPersonForPayment
        ) {
          this.setState({
            ibanUsedForEntity: person,
          });
        }

        if (
          (!!company &&
            !!this.state.selectedCompanyForPayment &&
            company.id !== this.state.selectedCompanyForPayment.id) ||
          !this.state.selectedCompanyForPayment
        ) {
          this.setState({
            ibanUsedForEntity: company,
          });
        }
      }

      payment.mainBankAccountId = iban;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_CREATE_START,
        payload: {
          payment: payment,
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
          });

          if (this.state.nextPath) {
            return this.redirect(this.state.nextPath);
          }

          this.initializePage(this.state.charge?.id);
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false,
            skipCreateExtraPayment: false,
            skipCreateAdditionalCharge: false,
            shouldCreateExtraPayment: false,
            shouldCreateAdditionalCharge: false,
            shouldSettleTheDifference: false,
            anchorEl: null,
          });
        },
      });
    });
  };

  public linkPaymentWithCharge = (charge: ChargeInterface): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_LINK_START,
      payload: {
        charge: charge,
        paymentIds: this.state.paymentIds,
      },
      onSuccess: () => {
        this.props.dispatch({
          type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
        });

        if (this.state.nextPath) {
          return this.redirect(this.state.nextPath);
        }

        this.setState({
          hasModifiedData: false,
          isSaving: false,
        });

        this.initializePage(this.state.charge?.id);
      },
      onError: () => {
        this.setState({
          hasModifiedData: true,
          isSaving: false,
          skipCreateExtraPayment: false,
          skipCreateAdditionalCharge: false,
          shouldCreateExtraPayment: false,
          shouldCreateAdditionalCharge: false,
          anchorEl: null,
        });
      },
    });
  };

  public settleWithCharge = (selectedCharge: ChargeInterface) => {
    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_SETTLE_START,
          payload: {
            id: this.state.charge && this.state.charge.id,
            existedChargeId: selectedCharge.id,
          },
          onSuccess: () => {
            this.setState(
              {
                isSaving: false,
                hasModifiedData: false,
                isSettleChargePopupOpen: false,
                directIndirectCharges: [],
                objectCharges: [],
                selectedDirectIndirectChargesRows: [],
                selectedObjectChargesRows: [],
                chargeSearchString: '',
              },
              () => {
                this.props.dispatch({
                  type: Constants.SNACKBAR_ADD_MESSAGE,
                  payload: {
                    message: this.trans(
                      'dialog/postprocess-info/paymentwascreated'
                    ),
                    type: 'info',
                  },
                  onSuccess: () => {
                    this.initializePage(this.state.charge?.id);
                  },
                });

                this.props.dispatch({
                  type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
                });

                if (this.state.nextPath) {
                  return this.redirect(this.state.nextPath);
                }

                this.initializePage(this.state.charge?.id);
              }
            );
          },
          onError: () => {
            this.setState({
              hasModifiedData: true,
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public save = (): any => {
    // readonly charges could not be updated because of this we shouldn't send update request
    if (
      this.state.paymentIds &&
      this.state.paymentIds.length > 0 &&
      !this.state.isEditableView
    ) {
      return this.setState(
        {
          isSaving: true,
          hasModifiedData: true,
        },
        () => {
          return this.linkPaymentWithCharge(this.state.charge);
        }
      );
    }

    const charge: any = {
      description: this.state.descriptionForCharge,
      amount: parseFloat(
        parseFloat(
          String(
            Formatter.deleteExtraSpace(this.state.amountForCharge)
          ).replace(',', '.')
        ).toFixed(2)
      ),
      currency: this.state.currencyIdForCharge,
      type: this.state.typeIdForCharge,
      dueDate: Time.formatOrNull(this.state.dueDateForCharge),
      firstDate: Time.formatOrNull(this.state.firstDateForCharge),
      period: this.state.periodForCharge,
      invoiceDate: Time.formatOrNull(this.state.invoiceDateForCharge),
      invoiceNumber: this.state.invoiceNumberForCharge,
      vat: parseFloat(
        parseFloat(
          String(Formatter.deleteExtraSpace(this.state.vatForCharge)).replace(
            ',',
            '.'
          )
        ).toFixed(2)
      ),
      isInvoice: this.state.isInvoice,
      dateOfPeriod: Time.formatOrNull(this.state.dateOfPeriodForCharge),
    };

    if (!this.state.charge?.automaticallyCreated) {
      // charge.dateOfPeriod = Time.formatOrNull(this.state.dateOfPeriodForCharge);
      charge.dueDate = Time.formatOrNull(
        Time.firstDateSelectedMonth(this.state.dateOfPeriodForCharge)
      );
    }

    if (this.state.selectedEntityForCharge instanceof Property) {
      charge.propertyId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Unit) {
      charge.unitId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Contract) {
      charge.contractId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Company) {
      charge.ownerId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Event) {
      charge.eventId = this.state.selectedEntityForCharge?.id;
    }

    if (!this.state.selectedEntityForCharge) {
      charge.propertyId = null;
      charge.unitId = null;
      charge.contractId = null;
      charge.ownerId = null;
      charge.eventId = null;
    }

    if (this.state.selectedCounterpartyForCharge instanceof Person) {
      charge.contactId = this.state.selectedCounterpartyForCharge?.id;
    }

    if (this.state.selectedCounterpartyForCharge instanceof Company) {
      charge.companyId = this.state.selectedCounterpartyForCharge?.id;
    }

    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: this.state.charge && this.state.charge.id,
          charge: charge,
        },
        onSuccess: (charge: ChargeInterface) => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
          });

          if (this.state.paymentIds && this.state.paymentIds.length === 0) {
            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
            });

            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }

            return this.initializePage(this.state.charge?.id);
          }

          return this.setState(
            {
              hasModifiedData: true,
            },
            () => {
              return this.linkPaymentWithCharge(charge);
            }
          );
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            anchorEl: null,
          });
        },
      });
    });
  };

  public setDescriptionEqualToType(typeName: string, date: string) {
    if (
      this.state.descriptionManuallyChanged === false &&
      this.state.chargeDescriptionAutomatic &&
      !this.state.checkTypeDescriptionPeriod
    ) {
      if (!!typeName) {
        this.setState({
          descriptionForCharge: typeName + ', ' + date,
        });
      } else {
        this.setState({
          descriptionForCharge: date,
        });
      }
    } else if (
      this.state.descriptionManuallyChanged === false &&
      this.state.chargeDescriptionAutomatic &&
      this.state.checkTypeDescriptionPeriod
    ) {
      this.setState({
        descriptionForCharge:
          typeName + ', ' + this.state.typeDescriptionSecondParametr,
      });
    }
  }

  public saveDraft = (message) => {
    this.setState({
      note: message,
    });
  };

  public selectDate = (date: Date, identifier: string): void => {
    if (
      !date &&
      (identifier === 'firstDateOfStatementPeriodForPayment' ||
        identifier === 'dateOfThePayment' ||
        identifier === 'paymentDateQuickOption')
    ) {
      return;
    }

    let selectedDate = date;

    if (date) {
      if (
        identifier === 'dateOfPeriodForCharge' ||
        (identifier === 'firstDateForCharge' &&
          this.state.periodForCharge === 3)
      ) {
        // todo fix hardcoded value
        selectedDate = Time.firstDateSelectedMonth(date);
      }
    }

    this.setState(
      {
        [identifier]: selectedDate,
        hasModifiedData: true,
      },
      () => {
        if (identifier === 'dateOfPeriodForCharge') {
          let typeName;

          if (!!this.state.type) {
            const type = this.getChargeTypeBySelect(this.state.type);
            typeName = Formatter.checkTranslationType(
              this.trans(type?.label, {}, '', type?.system),
              type?.label,
              type?.system
            );
          } else {
            typeName = Formatter.checkTranslationType(
              this.trans(this.state.chargeTypeObj?.label, {}, '', false),
              this.state.chargeTypeObj?.label,
              this.state.chargeTypeObj?.system
            );
          }

          this.setModifiedData();
          this.setDescriptionEqualToType(
            typeName,
            this.formatter.monthFullFormatDate(date)
          );
        }

        if (identifier === 'firstDateForCharge') {
          // payment default date should be in the same period as charge
          this.selectDate(
            this.state.firstDateForCharge,
            'firstDateOfStatementPeriodForPayment'
          );
        }
      }
    );
  };

  public delete = () => {
    const payment = this.state.paymentToDelete;

    this.setState({
      isSaving: true,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_START,
      payload: {
        payment: payment,
      },
      onSuccess: () => {
        this.initializePage(this.state.charge && this.state.charge.id);
      },
      onError: () => {
        this.setState({
          isSaving: false,
        });
      },
    });
  };
  public undoPaidToOwner = () => {
    const payment = this.state.paymentToDelete;
    this.setState({
      isSaving: true,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_START,
      payload: {
        payment: payment,
      },
      onSuccess: () => {
        this.initializePage(this.state.charge && this.state.charge.id);
      },
      onError: () => {
        this.setState({
          isSaving: false,
        });
      },
    });
  };

  public closePrompt(): void {
    this.setState({
      isPaymentUnlinkPopupOpen: false,
      isPaymentRemovePopupOpen: false,
    });
  }

  protected openMenu = (event: any, payment: PaymentInterface): void => {
    this.selectedPayment = payment;

    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null,
    });
  };

  public unlinkPayment = (): any => {
    const payment: PaymentInterface = this.state.paymentToDelete;

    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_PAYMENT_UNLINK_START,
          payload: {
            charge: this.state.charge,
            payment: payment,
          },
          onSuccess: () => {
            this.initializePage(this.state.charge && this.state.charge.id);
          },
          onError: () => {
            this.setState({
              isPaymentUnlinkPopupOpen: false,
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public createPayment() {
    if (!this.state.charge) {
      return null;
    }

    return this.redirect(`/app/charge/link/${this.state.charge.id}`);
  }

  public getChargeTypeBySelect = (id) => {
    const chargeType =
      Store.getConfigurator().getState().globalTypes?.ChargeType;
    if (!!id) {
      for (const key in chargeType) {
        if (chargeType[key].id === id) {
          return chargeType[key];
        }
      }
    }
  };

  public changeAmountForCharge = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state.vatForCharge) {
      let amountForCharge: number = parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(amount)).replace(',', '.')
        ).toFixed(2)
      );
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;
      let vatPercentageNumber: any = parseFloat(
        parseFloat(
          String(
            this.formatter.deleteExtraSpace(this.state.vatPercentageForCharge)
          ).replace(',', '.')
        ).toFixed(2)
      );
      vatPercentageNumber = isNaN(vatPercentageNumber)
        ? 0
        : vatPercentageNumber;

      const vatNumber =
        (amountForCharge / (100 + vatPercentageNumber)) * vatPercentageNumber;
      return this.setState({
        vatForCharge: this.formatter.simpleFormatNumber(
          Math.round(vatNumber * 100 + Number.EPSILON) / 100,
          false
        ),
        amountForCharge: amount,
        hasModifiedData: true,
      });
    }

    if (this.state.vatPercentageForCharge) {
      let amountForCharge: number = parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(amount)).replace(',', '.')
        ).toFixed(2)
      );
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

      let vatPercentageNumber: any = parseFloat(
        parseFloat(
          String(
            this.formatter.deleteExtraSpace(this.state.vatPercentageForCharge)
          ).replace(',', '.')
        ).toFixed(2)
      );
      vatPercentageNumber = isNaN(vatPercentageNumber)
        ? 0
        : vatPercentageNumber;

      const vatNumber =
        (amountForCharge / (100 + vatPercentageNumber)) * vatPercentageNumber;
      return this.setState({
        vatForCharge: this.formatter.simpleFormatNumber(
          Math.round(vatNumber * 100 + Number.EPSILON) / 100,
          false
        ),
        amountForCharge: amount,
        hasModifiedData: true,
      });
    }

    return this.setState({
      vatForCharge: '',
      vatPercentageForCharge: '',
      amountForCharge: amount,
      amountForPayment: amount,
      hasModifiedData: true,
    });
  };

  public changeCurrencyIdForCharge = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      currencyIdForCharge: currency,
      hasModifiedData: true,
    });
  };

  public changeChargeOwnerChoice = (event, callback): void => {
    const choice: string = event.target.value;

    this.setState(
      {
        payerChoice: choice,
        chargeOwnerChoice: choice,
        selectedPersonForPayment: null,
        selectedCompanyForPayment: null,
        selectedPersonForCharge: null,
        selectedCompanyForCharge: null,
        counterpartyIbanForPayment: '',
        originalCounterpartyIban: '',
        counterpartyIbanForPaymentWasChanged: false,
        directIndirectCharges: [],
        selectedDirectIndirectChargesRows: [],
        hasModifiedData: true,
      },
      () => {
        // hack to rerender charge owner choice
        this.setState({ showPayerChoice: false }, () => {
          this.setState({ showPayerChoice: true }, () => {
            if (typeof callback === 'function') {
              callback(choice);
            }
          });
        });
      }
    );
  };

  public selectPersonForCharge = (
    person: PersonInterface,
    isManuallySelected: boolean
  ): void => {
    this.setState(
      {
        selectedPersonForCharge: person,
        selectedPersonForPayment: person,
        hasModifiedData: isManuallySelected
          ? isManuallySelected
          : this.state.hasModifiedData,
      },
      () => {
        this.fetchDirectIndirectPayments();
        this.fetchExistingCharges();

        // hack to rerender charge owner choice
        this.setState({ showPayerChoice: false }, () => {
          this.setState({ showPayerChoice: true }, () => {
            // need this logic to ask if user wants to update iban for person
            if (
              (!this.state.counterpartyIbanForPayment ||
                (this.state.counterpartyIbanForPayment &&
                  !this.state.counterpartyIbanForPaymentIsManuallyChanged)) &&
              person?.mainBankAccountId
            ) {
              return this.setState({
                counterpartyIbanForPayment: person?.mainBankAccountId,
                originalCounterpartyIban: person?.mainBankAccountId,
                counterpartyIbanForPaymentWasChanged: false,
              });
            }
          });
        });
      }
    );
  };

  public clearPersonForCharge = (): void => {
    const personMainBankAccountId: string =
      this.state.selectedPersonForPayment?.mainBankAccountId;

    this.setState(
      {
        selectedPersonForCharge: null,
        selectedPersonForPayment: null,
        directIndirectPayments: [],
        selectedDirectIndirectPaymentsRows: [],
        hasModifiedData: true,
      },
      () => {
        if (personMainBankAccountId === this.state.counterpartyIbanForPayment) {
          return this.setState({
            counterpartyIbanForPayment: '',
            originalCounterpartyIban: '',
            counterpartyIbanForPaymentWasChanged: false,
          });
        }
      }
    );
  };

  public selectCompanyForCharge = (
    company: CompanyInterface,
    isManuallySelected: boolean
  ): void => {
    this.setState(
      {
        selectedCompanyForCharge: company,
        selectedCompanyForPayment: company,
        hasModifiedData: isManuallySelected
          ? isManuallySelected
          : this.state.hasModifiedData,
      },
      () => {
        this.fetchDirectIndirectPayments();
        this.fetchExistingCharges();

        // hack to rerender charge owner choice
        this.setState({ showPayerChoice: false }, () => {
          this.setState({ showPayerChoice: true }, () => {
            // need this logic to ask if user wants to update iban for person
            if (
              (!this.state.counterpartyIbanForPayment ||
                (this.state.counterpartyIbanForPayment &&
                  !this.state.counterpartyIbanForPaymentIsManuallyChanged)) &&
              company?.mainBankAccountId
            ) {
              return this.setState({
                counterpartyIbanForPayment: company?.mainBankAccountId,
                originalCounterpartyIban: company?.mainBankAccountId,
                counterpartyIbanForPaymentWasChanged: false,
              });
            }
          });
        });
      }
    );
  };

  public clearCompanyForCharge = (): void => {
    const companyMainBankAccountId: string =
      this.state.selectedCompanyForPayment?.mainBankAccountId;

    this.setState(
      {
        selectedCompanyForCharge: null,
        selectedCompanyForPayment: null,
        directIndirectPayments: [],
        selectedDirectIndirectPaymentsRows: [],
        hasModifiedData: true,
      },
      () => {
        if (
          companyMainBankAccountId === this.state.counterpartyIbanForPayment
        ) {
          return this.setState({
            counterpartyIbanForPayment: '',
            originalCounterpartyIban: '',
            counterpartyIbanForPaymentWasChanged: false,
          });
        }
      }
    );
  };

  public selectCounterpartyForCharge = (
    entity: CompanyInterface | PersonInterface
  ): void => {
    this.setState(
      {
        selectedCounterpartyForCharge: entity,
        payerChoice: entity instanceof Person ? 'person' : 'company',
        selectedPersonForCharge:
          entity instanceof Person
            ? entity
            : this.state.selectedPersonForCharge,
        selectedPersonForPayment:
          entity instanceof Person
            ? entity
            : this.state.selectedPersonForPayment,
        selectedCompanyForCharge:
          entity instanceof Company
            ? entity
            : this.state.selectedCompanyForCharge,
        selectedCompanyForPayment:
          entity instanceof Company
            ? entity
            : this.state.selectedCompanyForPayment,
        hasModifiedData: true,
      },
      () => {
        this.fetchDirectIndirectPayments();
        this.fetchExistingCharges();

        // hack to rerender charge owner choice
        this.setState({ showPayerChoice: false }, () => {
          this.setState({ showPayerChoice: true }, () => {
            // need this logic to ask if user wants to update iban for person
            if (
              (!this.state.counterpartyIbanForPayment ||
                (this.state.counterpartyIbanForPayment &&
                  !this.state.counterpartyIbanForPaymentIsManuallyChanged)) &&
              entity?.mainBankAccountId
            ) {
              return this.setState({
                counterpartyIbanForPayment: entity?.mainBankAccountId,
                originalCounterpartyIban: entity?.mainBankAccountId,
                counterpartyIbanForPaymentWasChanged: false,
              });
            }
          });
        });
      }
    );
  };

  public clearCounterpartyForCharge = (): void => {
    this.setState({
      selectedPersonForCharge: null,
      selectedPersonForPayment: null,
      selectedCounterpartyForCharge: null,
      selectedCompanyForCharge: null,
      selectedCompanyForPayment: null,
      directIndirectPayments: [],
      selectedDirectIndirectPaymentsRows: [],
      hasModifiedData: true,
    });
  };

  public openEditableView = (): void => {
    this.setState({
      isEditableView: true,
    });
  };

  public changeTypeIdForCharge = (...args: any[]): void => {
    if (!!args[1].props.value) {
      const type = this.getChargeTypeBySelect(args[1].props.value);
      const typeName = Formatter.checkTranslationType(
        this.trans(type?.label, {}, '', type?.system),
        type?.label,
        type?.system
      );
      const chargeClassId: number =
        this.props?.globalTypes?.ChargeType?.[type?.id]?.chargeClassId;

      this.setState(
        {
          typeIdForCharge: type.id,
          paymentClassId: String(chargeClassId),
          chargeClassId: chargeClassId,
          hasModifiedData: true,
        },
        () =>
          this.setState({ renderChargeType: false }, () => {
            this.setState({ renderChargeType: true });
            this.fetchDirectIndirectPayments();
            this.fetchExistingCharges();
          })
      );

      this.setDescriptionEqualToType(
        typeName,
        this.formatter.monthFullFormatDate(this.state.firstDateForCharge)
      );
    }
  };

  public addChargeType = (chargeType: object, callback?): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TYPE_CREATE_START,
        payload: {
          chargeType: chargeType,
        },
        onSuccess: (chargeType) => {
          const chargeClassId: number = chargeType?.chargeClassId;
          this.setState({
            isSaving: false,
            typeIdForCharge: chargeType.id,
            isCreateChargeTypePopupOpen: false,
            hasModifiedData: true,
            paymentClassId: String(chargeClassId),
          });

          this.setDescriptionEqualToType(
            chargeType.label,
            this.formatter.monthFullFormatDate(this.state.firstDateForCharge)
          );

          if (typeof callback === 'function') {
            callback();
          }
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false,
          });
        },
      });
    });
  };

  public getStatementPeriodForCharge = () => {
    console.log(this.state.charge.type.id, TypeContainer.pickIdFromLabel('Overpaid_payable'), TypeContainer.pickIdFromLabel('Overpaid_receivable'))
    if (
      this.state.charge.type.id ===
        TypeContainer.pickIdFromLabel('Overpaid_payable') ||
      this.state.charge.type.id ===
        TypeContainer.pickIdFromLabel('Overpaid_receivable')
    ) {
      return;
    }
    const payload: any = {
      statementPeriod: Time.formatOrNull(this.state.firstDateForCharge),
    };

    if (this.state.selectedEntityForCharge instanceof Property) {
      payload.propertyId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Unit) {
      payload.unitId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Contract) {
      payload.contractId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Company) {
      payload.ownerId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Event) {
      payload.eventId = this.state.selectedEntityForCharge.id;
    }

    // if (this.state.selectedPersonForCharge?.id) {
    //   payload.contactId = this.state.selectedPersonForCharge?.id;
    // }

    // if (this.state.selectedCompanyForCharge?.id) {
    //   payload.companyId = this.state.selectedCompanyForCharge?.id;
    // }

    if (this.state.selectedCounterpartyForCharge instanceof Person) {
      payload.contactId = this.state.selectedCounterpartyForCharge?.id;
    }

    if (this.state.selectedCounterpartyForCharge instanceof Company) {
      payload.companyId = this.state.selectedCounterpartyForCharge?.id;
    }

    return this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_PERIOD,
      payload: {
        ...payload,
      },
      onSuccess: (data) => {
        if (data?.financialStartDate) {
          this.setState({
            financialStatementPeriodMinDate: new Date(data?.financialStartDate),
          });
        }
      },
    });
  };

  public selectEntityForCharge = (
    entity: PropertyInterface | UnitInterface | ContractInterface
  ): void => {
    this.setState(
      {
        selectedEntityForCharge: entity,
        selectedEntityForChargeManuallyChanged: true,
        hasModifiedData: true,
      },
      this.getStatementPeriodForCharge
    );
  };

  public clearEntityForCharge = (): void => {
    this.setState({
      selectedEntityForCharge: null,
      selectedEntityForChargeManuallyChanged: true,
      hasModifiedData: true,
    });
  };

  public changePeriodForCharge = (event): void => {
    let period: number = event.target.value;

    this.setState({
      periodForCharge: period,
      hasModifiedData: true,
    });
  };

  public changeDescriptionForCharge = (event): void => {
    const description: string = event.target.value;

    this.setState(
      {
        descriptionForCharge: description,
        hasModifiedData: true,
        descriptionForChargeIsManuallyChanged: true,
      },
      () => {
        if (!this.state.descriptionForPaymentIsManuallyChanged) {
          this.setState({
            descriptionForPayment: description,
          });
        }
      }
    );
  };

  public changeInvoiceNumberForCharge = (event): void => {
    const invoiceNumber: string = event.target.value;

    this.setState({
      invoiceNumberForCharge: invoiceNumber,
      hasModifiedData: true,
    });
  };

  public changeVatForCharge = (event): void => {
    let vat: string = event.target.value;
    vat = this.formatter.formatSigns(vat);

    let amountForCharge: number = parseFloat(
      parseFloat(
        String(
          this.formatter.deleteExtraSpace(this.state.amountForCharge)
        ).replace(',', '.')
      ).toFixed(2)
    );
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatNumber: any = parseFloat(
      parseFloat(
        String(this.formatter.deleteExtraSpace(vat)).replace(',', '.')
      ).toFixed(2)
    );
    vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

    const vatPercentageNumber =
      (vatNumber / (amountForCharge - vatNumber)) * 100;

    this.setState({
      vatForCharge: vat,
      vatPercentageForCharge: isNaN(vatPercentageNumber)
        ? 0
        : this.formatter.simpleFormatNumber(
            Math.round(vatPercentageNumber),
            false,
            false
          ),
      hasModifiedData: true,
    });
  };

  public changeVatPercentageForCharge = (event): void => {
    let vatPercentage: string = event.target.value;
    vatPercentage = this.formatter.formatSigns(vatPercentage);

    let amountForCharge: number = parseFloat(
      parseFloat(
        String(
          this.formatter.deleteExtraSpace(this.state.amountForCharge)
        ).replace(',', '.')
      ).toFixed(2)
    );
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatPercentageNumber: any = parseFloat(
      parseFloat(
        String(this.formatter.deleteExtraSpace(vatPercentage)).replace(',', '.')
      ).toFixed(2)
    );
    vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

    const vatNumber =
      (amountForCharge / (100 + vatPercentageNumber)) * vatPercentageNumber;

    this.setState({
      vatForCharge: this.formatter.simpleFormatNumber(
        Math.round(vatNumber * 100 + Number.EPSILON) / 100,
        false
      ),
      vatPercentageForCharge: vatPercentage,
      hasModifiedData: true,
    });
  };

  //
  // PAYMENT
  //

  public changeAmountForPayment = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      amountForPayment: amount,
      additionalSectionHasModifiedData: true,
    });
  };

  public changeCurrencyIdForPayment = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      currencyIdForPayment: currency,
      additionalSectionHasModifiedData: true,
    });
  };

  public changeTypeIdForPayment = (event): void => {
    const type = String(event.target.value);

    this.setState({
      typeNameForPayment:
        type == PaymentTypeContainer.pickIdFromLabel('Bank') ? 'Bank' : null,
      typeIdForPayment: type,
      additionalSectionHasModifiedData: true,
    });
  };

  public updateAgencyBankAccountIdForPayment = (event): void => {
    const bankAccountId: number = event.target.value;

    if (bankAccountId) {
      this.setState({
        agencyBankAccountIdForPayment: bankAccountId,
        additionalSectionHasModifiedData: true,
      });
    }
  };

  public addBankAccount = (bankAccount: object): void => {
    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_START,
          payload: {
            bankAccount: bankAccount,
          },
          onSuccess: (bankAccount: BankAccountInterface) => {
            this.setState({
              isSaving: false,
              isCreateBankAccountPopupOpen: false,
              agencyBankAccountIdForPayment: bankAccount.id,
            });
          },
          onError: () => {
            this.setState({
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public changeCounterpartyIbanForPayment = (event): void => {
    const counterpartyIbanForPayment: string = event.target.value;

    this.setState({
      counterpartyIbanForPayment: counterpartyIbanForPayment,
      counterpartyIbanForPaymentWasChanged: true,
      additionalSectionHasModifiedData: true,
    });
  };

  public changePaymentClassId = (event): void => {
    const paymentClassId = String(event.target.value);

    this.setState({
      paymentClassId: paymentClassId,
      additionalSectionHasModifiedData: true,
    });
  };

  public changePayerChoice = (event, callback): void => {
    this.clearPersonForPayment();
    this.clearCompanyForPayment();

    const choice: string = event.target.value;

    this.setState(
      {
        payerChoice: choice,
        selectedPersonForPayment: null,
        selectedCompanyForPayment: null,
        additionalSectionHasModifiedData: true,
      },
      () => {
        if (typeof callback === 'function') {
          callback(choice);
        }
      }
    );
  };

  public selectPersonForPayment = (
    person: PersonInterface,
    isManuallySelected: boolean
  ): void => {
    return this.setState(
      {
        selectedPersonForPayment: person,
        additionalSectionHasModifiedData: isManuallySelected
          ? isManuallySelected
          : this.state.additionalSectionHasModifiedData,
      },
      () => {
        // need this logic to ask if user wants to update iban for person
        if (
          (!this.state.counterpartyIbanForPayment ||
            (this.state.counterpartyIbanForPayment &&
              !this.state.counterpartyIbanForPaymentIsManuallyChanged)) &&
          person?.mainBankAccountId
        ) {
          return this.setState({
            counterpartyIbanForPayment: person?.mainBankAccountId,
            originalCounterpartyIban: person?.mainBankAccountId,
            counterpartyIbanForPaymentWasChanged: false,
          });
        }
      }
    );
  };

  public clearPersonForPayment = (): void => {
    const personMainBankAccountId: string =
      this.state.selectedPersonForPayment?.mainBankAccountId;

    return this.setState(
      {
        selectedPersonForPayment: null,
        additionalSectionHasModifiedData: true,
      },
      () => {
        if (personMainBankAccountId === this.state.counterpartyIbanForPayment) {
          return this.setState({
            counterpartyIbanForPayment: '',
            originalCounterpartyIban: '',
            counterpartyIbanForPaymentWasChanged: false,
          });
        }
      }
    );
  };

  public selectCompanyForPayment = (
    company: CompanyInterface,
    isManuallySelected: boolean
  ): void => {
    return this.setState(
      {
        selectedCompanyForPayment: company,
        additionalSectionHasModifiedData: isManuallySelected
          ? isManuallySelected
          : this.state.additionalSectionHasModifiedData,
      },
      () => {
        // need this logic to ask if user wants to update iban for person
        if (
          (!this.state.counterpartyIbanForPayment ||
            (this.state.counterpartyIbanForPayment &&
              !this.state.counterpartyIbanForPaymentIsManuallyChanged)) &&
          company?.mainBankAccountId
        ) {
          return this.setState({
            counterpartyIbanForPayment: company?.mainBankAccountId,
            originalCounterpartyIban: company?.mainBankAccountId,
            counterpartyIbanForPaymentWasChanged: false,
          });
        }
      }
    );
  };

  public clearCompanyForPayment = (): void => {
    const companyMainBankAccountId: string =
      this.state.selectedCompanyForPayment?.mainBankAccountId;

    return this.setState(
      {
        selectedCompanyForPayment: null,
        additionalSectionHasModifiedData: true,
      },
      () => {
        if (
          companyMainBankAccountId === this.state.counterpartyIbanForPayment
        ) {
          return this.setState({
            counterpartyIbanForPayment: '',
            originalCounterpartyIban: '',
            counterpartyIbanForPaymentWasChanged: false,
          });
        }
      }
    );
  };

  public changeDescriptionForPayment = (event): void => {
    const description: string = event.target.value;
    this.setState({
      descriptionForPayment: description,
      descriptionForPaymentIsManuallyChanged: true,
      additionalSectionHasModifiedData: true,
    });
  };

  public openCreateBankAccountPopup = (): void => {
    this.setState({ isCreateBankAccountPopupOpen: true });
  };

  public changePaymentChoiceView = (event): void => {
    const choice: string = event.target.value;

    if (choice === this.state.paymentChoice) {
      return this.setState({
        paymentChoice: 'existing',
        selectedDirectIndirectPaymentsRows: [],
        selectedPayerPaymentsRows: [],
        paymentIds: [],
        selectedDirectIndirectChargesRows: [],
        chargeIds: [],
        selectedCharge: null,
        additionalSectionHasModifiedData: false,
      });
    } else {
      return this.setState(
        {
          paymentChoice: choice,
        },
        () => {
          if (choice === 'existing') {
            this.fetchDirectIndirectPayments();
          }

          if (choice === 'settle') {
            this.fetchExistingCharges();
          }

          // if (choice === "new") {
          //   this.setState({
          //     additionalSectionHasModifiedData: true
          //   });
          // }
        }
      );
    }
  };

  public fetchDirectIndirectPayments = (firstAutoCall?: boolean): void => {
    // const payload: any = {
    //   isFullyUsed: 0, // unused payments
    //   removed: 0,
    //   isAfterStartDate: 1, // do not fetch charges before start date
    // };

    // const chargeClassId: number = this.state.chargeClassId;

    // if (chargeClassId) {
    //   payload.paymentClassId = chargeClassId;
    // }

    // // !!this.state.selectedPersonForCharge ? payload.contactId = this.state.selectedPersonForCharge.id : null;
    // // !!this.state.selectedCompanyForCharge ? payload.companyId = this.state.selectedCompanyForCharge.id : null;

    // if (this.state.selectedCounterpartyForCharge instanceof Person) {
    //   payload.contactId = this.state.selectedCounterpartyForCharge?.id;
    // }

    // if (this.state.selectedCounterpartyForCharge instanceof Company) {
    //   payload.companyId = this.state.selectedCounterpartyForCharge?.id;
    // }
    // this.setState({
    //   showHintBox: false
    // })

    return this.props.dispatch({
      type: Constants.GLOBAL_GET_MATCHED_PAYMENTS_LIST,
      payload: {
        chargeId: this.state?.charge?.id,
      },
      onSuccess: (data) => {
        this.setState(
          {
            directIndirectPayments: data,
            // showHintBox: true
          },
          () => {
            if (firstAutoCall && this.state.directIndirectPayments?.length) {
              this.setState({
                paymentChoice: 'existing',
              });
            }
          }
        );
      },
    });
  };

  // we should payments which are related to selected person or company for pay charge page
  public fetchPayerPayments = (): void => {
    const mainPayload: any = {
      isFullyUsed: 0, // unused payments
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
    };

    const chargeClassId: number = this.state.chargeClassId;

    if (chargeClassId) {
      mainPayload.paymentClassId = chargeClassId;
    }

    // search for charges
    if (!!this.state.paymentSearchString) {
      this.setState(
        {
          paymentSearchInProgress: true,
        },
        () => {
          const payload = {
            ...mainPayload,
            filterValue: this.state.paymentSearchString,
          };

          this.props.dispatch({
            type: Constants.GLOBAL_PAYMENTS_NOT_SAVE_LIST,
            payload: { ...payload },
            onSuccess: (data) => {
              this.setState({
                payerPayments: data.payments,
                paymentSearchInProgress: false,
              });
            },
          });
        }
      );
    } else {
      this.setState({
        payerPayments: [],
        paymentSearchInProgress: false,
      });
    }
  };

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: '11px',
          color: '#80808091',
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  };

  public getPayments = (
    payments: PaymentInterface[],
    selectedPaymentsRows: number[],
    callback: any
  ): any => {
    return payments
      .filter((payment) => !!payment)
      .map((payment: PaymentInterface, index: number) => {
        let color = '#43A047';

        if (payment.amountUsed < payment.amount) {
          if (payment.amountUsed === 0) {
            color = '#F44336';
          } else {
            color = '#F5A623';
          }
        }

        if (!payment) {
          return;
        }
        const isItemSelected = selectedPaymentsRows.includes(index);
        const labelId = `enhanced-table-checkbox-${index}`;

        return (
          <TableRow
            hover
            key={`payment-${payment.id}`}
            onClick={() => {
              this.saveDetailsBeforeRedirect(
                `chargeUpdate-${this.state.charge?.id}-`
              );

              this.redirect(`/app/payment/update/${payment.id}`);
            }}
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            <TableCell
              padding="checkbox"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                callback(event, [index]);
              }}
            >
              <Checkbox
                checked={isItemSelected}
                inputProps={{ 'aria-labelledby': labelId }}
                color="primary"
              />
            </TableCell>
            <TableCell
              style={{
                width: '24px',
                paddingLeft: '10px',
                paddingRight: '5px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingTop: '4px',
                }}
              >
                <div
                  className="icon icon-ic-payment"
                  style={{ color: color }}
                ></div>
              </div>
            </TableCell>
            <TableCell style={{ width: '20%' }}>
              {this.formatter.formatDate(payment.dateOfThePayment)}
            </TableCell>
            <TableCell style={{ width: '40%' }}>
              <PaymentCounterpartyDescriptionInfoForList payment={payment} />
            </TableCell>
            <TableCell>
              {payment.creationTypeDisplayName && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div className="list-label creation-type-label">
                    {payment.creationTypeDisplayName}
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell style={{ textAlign: 'right', width: '40%' }}>
              <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
                <span>
                  {payment.paymentClass.id ==
                    PaymentClassContainer.pickIdFromLabel('Payable') && (
                    <span className="minus-style">{'-'}</span>
                  )}
                  {this.formatter.formatNumber(
                    payment.amount,
                    payment.currency
                  )}
                </span>
                {this.renderPaymentAmountHint(payment)}
              </div>
            </TableCell>
          </TableRow>
        );
      });
  };

  public selectUnselectDirectInDirectPayment = (
    row: number,
    paymentId: number
  ) => {
    if (this.state.selectedDirectIndirectPaymentsRows.includes(row)) {
      const selectedDirectIndirectPaymentsRows =
        this.state.selectedDirectIndirectPaymentsRows.filter(
          (rowId) => rowId !== row
        );
      const paymentIds = this.state.paymentIds.filter((id) => id !== paymentId);

      this.setState({
        selectedPayerPaymentsRows: [],
        selectedDirectIndirectPaymentsRows: selectedDirectIndirectPaymentsRows,
        paymentIds: paymentIds,
      });
    } else {
      const paymentsUnusedAmount: number = this.state.paymentIds
        .map((id) => {
          const payment: PaymentInterface =
            this.state.directIndirectPayments.find(
              (payment) => payment.id === id
            );
          const amountUnused = payment.amountRemaining;

          return amountUnused;
        })
        .reduce((a, b) => a + b, 0);
      const paymentUnusedAmount: number = parseFloat(
        (
          100 *
          parseFloat(
            String(
              Formatter.deleteExtraSpace(this.state.amountForPayment)
            ).replace(',', '.')
          )
        ).toFixed(2)
      );

      // we should not allow to select payment if:
      // user already selected chargesPaymentsLinkedLimitNumber payments
      // the sum of unpaid amounts are greater than charge unpaid amount
      if (paymentsUnusedAmount >= paymentUnusedAmount) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              'section/payment-info/cannottselectpaymentchargefullypaid'
            ),
            type: 'warning',
          },
        });
      }

      if (
        this.state.paymentIds.length ===
        this.props.app?.chargesPaymentsLinkedLimitNumber
      ) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              'section/payment-info/cannottselectpaymentmaxpaymentnumberselected',
              { number: this.props.app?.chargesPaymentsLinkedLimitNumber }
            ),
            type: 'warning',
          },
        });
      }

      this.setState(
        {
          selectedPayerPaymentsRows: [],
          selectedDirectIndirectPaymentsRows: [
            ...this.state.selectedDirectIndirectPaymentsRows,
            row,
          ],
          paymentIds: [...this.state.paymentIds, paymentId],
        },
        () => {
          if (this.state.paymentIds.length > 0) {
            this.setState({
              hasModifiedData: true,
            });
          }
        }
      );
    }
  };

  public onDirectInDirectPaymentRowSelection = (
    _event,
    rows: number[]
  ): void => {
    const row: number = rows[0];
    const paymentId: number = this.state.directIndirectPayments[row].id;

    // if there are payments selected in the other list first we should clear them
    if (this.state.selectedPayerPaymentsRows.length > 0) {
      this.setState(
        {
          selectedPayerPaymentsRows: [],
          paymentIds: [],
        },
        () => {
          // if user click on selected payment
          this.selectUnselectDirectInDirectPayment(row, paymentId);
        }
      );
    } else {
      this.selectUnselectDirectInDirectPayment(row, paymentId);
    }
  };

  public selectUnselectPayerPayment = (row: number, paymentId: number) => {
    if (this.state.selectedPayerPaymentsRows.includes(row)) {
      const selectedPayerPaymentsRows =
        this.state.selectedPayerPaymentsRows.filter((rowId) => rowId !== row);
      const paymentIds = this.state.paymentIds.filter((id) => id !== paymentId);

      this.setState({
        selectedDirectIndirectPaymentsRows: [],
        selectedPayerPaymentsRows: selectedPayerPaymentsRows,
        paymentIds: paymentIds,
      });
    } else {
      const paymentsUnusedAmount: number = this.state.paymentIds
        .map((id) => {
          const payment: PaymentInterface = this.state.payerPayments.find(
            (payment) => payment.id === id
          );
          const amountUnused = payment.amountRemaining;

          return amountUnused;
        })
        .reduce((a, b) => a + b, 0);
      const paymentUnusedAmount: number = parseFloat(
        (
          100 *
          parseFloat(
            String(
              Formatter.deleteExtraSpace(this.state.amountForPayment)
            ).replace(',', '.')
          )
        ).toFixed(2)
      );

      // we should not allow to select payment if:
      // user already selected chargesPaymentsLinkedLimitNumber payments
      // the sum of unpaid amounts are greater than charge unpaid amount
      if (paymentsUnusedAmount >= paymentUnusedAmount) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              'section/payment-info/cannottselectpaymentchargefullypaid'
            ),
            type: 'warning',
          },
        });
      }

      if (
        this.state.paymentIds.length ===
        this.props.app?.chargesPaymentsLinkedLimitNumber
      ) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              'section/payment-info/cannottselectpaymentmaxpaymentnumberselected',
              { number: this.props.app?.chargesPaymentsLinkedLimitNumber }
            ),
            type: 'warning',
          },
        });
      }

      this.setState(
        {
          selectedDirectIndirectPaymentsRows: [],
          selectedPayerPaymentsRows: [
            ...this.state.selectedPayerPaymentsRows,
            row,
          ],
          paymentIds: [...this.state.paymentIds, paymentId],
        },
        () => {
          if (this.state.paymentIds.length > 0) {
            this.setState({
              hasModifiedData: true,
            });
          }
        }
      );
    }
  };

  public onPayerPaymentRowSelection = (_event, rows: number[]): void => {
    const row: number = rows[0];
    const paymentId: number = this.state.payerPayments[row].id;

    // if there are payemnts selected in the other list first we should clear them
    if (this.state.selectedDirectIndirectPaymentsRows.length > 0) {
      this.setState(
        {
          selectedDirectIndirectPaymentsRows: [],
          paymentIds: [],
        },
        () => {
          // if user click on selected payment
          this.selectUnselectPayerPayment(row, paymentId);
        }
      );
    } else {
      this.selectUnselectPayerPayment(row, paymentId);
    }
  };

  public selectPersonForExistingPayments = (person: PersonInterface): void => {
    return this.setState(
      {
        selectedPersonForExistingPayments: person,
        payerPayments: [],
        selectedDirectIndirectPaymentsRows: [],
        selectedPayerPaymentsRows: [],
        paymentIds: [],
      },
      this.fetchPayerPayments
    );
  };

  public clearPersonForExistingPayments = (): void => {
    return this.setState({
      selectedPersonForExistingPayments: null,
      payerPayments: [],
      selectedDirectIndirectPaymentsRows: [],
      selectedPayerPaymentsRows: [],
      paymentIds: [],
    });
  };

  public selectCompanyForExistingPayments = (
    company: CompanyInterface
  ): void => {
    return this.setState(
      {
        selectedCompanyForExistingPayments: company,
        payerPayments: [],
        selectedDirectIndirectPaymentsRows: [],
        selectedPayerPaymentsRows: [],
        paymentIds: [],
      },
      this.fetchPayerPayments
    );
  };

  public clearCompanyForExistingPayments = (): void => {
    return this.setState({
      selectedCompanyForExistingPayments: null,
      selectedDirectpayerPaymentsIndirectPaymentsRows: [],
      selectedDirectIndirectPaymentsRows: [],
      selectedPayerPaymentsRows: [],
      paymentIds: [],
    });
  };

  public changeExistingPayerChoice = (event, callback): void => {
    const choice: string = event.target.value;

    this.setState(
      {
        existingPayerChoice: choice,
        selectedPersonForExistingPayments: null,
        selectedCompanyForExistingPayments: null,
        payerPayments: [],
        selectedDirectIndirectPaymentsRows: [],
        selectedPayerPaymentsRows: [],
        paymentIds: [],
      },
      () => {
        if (typeof callback === 'function') {
          callback(choice);
        }
      }
    );
  };

  public selectPersonForExistingCharges = (person: PersonInterface): void => {
    return this.setState(
      {
        selectedPersonForExistingCharges: person,
        objectCharges: [],
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [],
        chargeIds: [],
      },
      this.fetchExistingCharges
    );
  };

  public clearPersonForExistingCharges = (): void => {
    return this.setState({
      selectedPersonForExistingCharges: null,
      objectCharges: [],
      selectedDirectIndirectChargesRows: [],
      selectedObjectChargesRows: [],
      chargeIds: [],
    });
  };

  public selectCompanyForExistingCharges = (
    company: CompanyInterface
  ): void => {
    return this.setState(
      {
        selectedCompanyForExistingCharges: company,
        objectCharges: [],
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [],
        chargeIds: [],
      },
      this.fetchExistingCharges
    );
  };

  public clearCompanyForExistingCharges = (): void => {
    return this.setState({
      selectedCompanyForExistingCharges: null,
      objectCharges: [],
      selectedDirectIndirectChargesRows: [],
      selectedObjectChargesRows: [],
      chargeIds: [],
    });
  };

  public changeExistingChargesPayerChoice = (event, callback): void => {
    const choice: string = event.target.value;

    this.setState(
      {
        existingChargesPayerChoice: choice,
        selectedPersonForExistingCharges: null,
        selectedCompanyForExistingCharges: null,
        objectCharges: [],
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [],
        chargeIds: [],
      },
      () => {
        if (typeof callback === 'function') {
          callback(choice);
        }
      }
    );
  };

  protected openChargeMenu = (
    event: any,
    contract: ContractInterface
  ): void => {
    this.setState({
      contract: contract,
      anchorElCharge: event.currentTarget,
    });
  };

  protected closeChargeMenu = (): void => {
    this.setState({
      anchorElCharge: null,
    });
  };

  public deleteCharge = (): void => {
    if (this.state.charge?.hasSavingsType) {
      return this.setState({
        isChargeRemovePopupOpen: false,
        cannotDeleteSavingsChargeDialog: true,
      });
    }

    this.setState(
      {
        isSaving: true,
        isChargeRemovePopupOpen: false,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_DELETE_START,
          payload: {
            charge: this.state.charge,
          },
          onSuccess: () => {
            this.setState(
              {
                isSaving: false,
              },
              this.redirectBack
            );
          },
          onError: () => {
            this.setState({
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public unSettle = (): any => {
    const charge: ChargeInterface =
      this.state.chargeToUncredit ?? this.state.charge;

    this.setState({
      isSaving: true,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_UNSETTLE_START,
      payload: {
        chargeId: this.state.chargeIdToUnsettle
          ? this.state.chargeIdToUnsettle
          : charge?.id,
      },
      onSuccess: () => {
        const id: number = parseInt(this.props.params.id, 10);

        if (id) {
          this.initializePage(id);
        }

        this.setState({ isChargeUnSettlePopupOpen: false, isSaving: false });
      },
      onError: () => {
        this.setState({
          isSaving: false,
        });
      },
    });
  };

  public unlinkCharge = (): void => {
    this.setState(
      {
        isSaving: true,
        isMainChargeUnlinkPopupOpen: false,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_UNLINK_START,
          payload: {
            charge: this.state.charge,
          },
          onSuccess: () => {
            const id: number = parseInt(this.props.params.id, 10);
            if (id) {
              this.initializePage(id);
            }
            this.setState({ isSaving: false });
          },
          onError: () => {
            this.setState({
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public handleChangeIsInvoice = (event) => {
    this.setState({
      isInvoice: event.target.checked,
      hasModifiedData: true,
    });
  };

  public openMemoPopup = (charge: ChargeInterface) => {
    this.setState({
      chargeToAddNote: charge,
      note: charge?.note,
      memoPopupOpen: true,
      anchorElCharge: null,
    });
  };

  public saveReminder = (charge: ChargeInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: { note: this.state.note },
          updateMemo: true,
        },
        onSuccess: (charge: ChargeInterface) => {
          this.setState({
            isSaving: false,
            memoPopupOpen: false,
            note: charge.note,
            charge: charge,
          });
        },
        onError: () => {
          this.setState({ isSaving: false });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans('memo-can-not-be-updated'),
              type: 'warning',
            },
          });
        },
      });
    });
  };

  public removeReminder = (charge: ChargeInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: { note: '' },
          removeMemo: true,
        },
        onSuccess: (charge: ChargeInterface) => {
          this.setState({
            isSaving: false,
            memoPopupOpen: false,
            note: charge.note,
            charge: charge,
          });
        },
        onError: () => {
          this.setState({ isSaving: false });
        },
      });
    });
  };

  // should fetch charges for list related to contact/company or to some object
  public fetchExistingCharges = (): void => {
    const chargeClassId =
      this.state.chargeClassId ==
      ChargeClassContainer.pickIdFromLabel('Payable')
        ? ChargeClassContainer.pickIdFromLabel('Receivable')
        : ChargeClassContainer.pickIdFromLabel('Payable');

    const mainPayload: any = {
      chargeClassId: chargeClassId,
      paid: 0, // unpaid charges
      isAfterStartDate: 1, // do not fetch charges before start date
      toSettleChargeId: this.state.charge?.id,
    };

    // manually search charges for settling
    if (!!this.state.chargeSearchString) {
      this.setState(
        {
          chargeSearchInProgress: true,
        },
        () => {
          const payload = {
            ...mainPayload,
            filterValue: this.state.chargeSearchString,
          };

          this.props.dispatch({
            type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
            payload: { ...payload },
            onSuccess: (data) => {
              const filteredCharges = data.charges.filter(
                (charge) =>
                  charge.type.id !== TypeContainer.pickIdFromLabel('Settlement')
              );

              this.setState({
                objectCharges: filteredCharges,
                chargeSearchInProgress: false,
              });
            },
          });
        }
      );
    } else {
      this.setState({
        objectCharges: [],
        chargeSearchInProgress: false,
      });
    }

    // should find charges for settle with the same counterparty
    if (!!this.state.selectedCounterpartyForCharge) {
      const payload = {
        ...mainPayload,
      };

      if (this.state.selectedCounterpartyForCharge instanceof Person) {
        payload.contactId = this.state.selectedCounterpartyForCharge?.id;
      }

      if (this.state.selectedCounterpartyForCharge instanceof Company) {
        payload.companyId = this.state.selectedCounterpartyForCharge?.id;
      }

      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
        payload: { ...payload },
        onSuccess: (data) => {
          const filteredCharges = data.charges.filter(
            (charge) =>
              charge.type.id !== TypeContainer.pickIdFromLabel('Settlement')
          );

          this.setState({
            directIndirectCharges: filteredCharges,
          });
        },
      });
    }
  };

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
      return;
    }

    if (
      0 < charge?.amountRemaining &&
      charge?.amountRemaining < charge?.amount &&
      charge?.isPayable
    ) {
      status = `${this.formatter.formatNumber(
        charge.amountRemaining,
        charge.currency
      )} ${this.trans('status-still-to-pay')}`;
    } else if (
      0 < charge?.amountRemaining &&
      charge?.amountRemaining < charge?.amount &&
      charge?.isReceivable
    ) {
      status = `${this.formatter.formatNumber(
        charge.amountRemaining,
        charge.currency
      )} ${this.trans('status-still-to-receive')}`;
    } else if (
      charge?.amountRemaining === charge?.amount &&
      charge?.isPayable &&
      !charge.isFullyPaid()
    ) {
      status = `${this.trans('status-to-pay')}`;
    } else if (
      charge?.amountRemaining === charge?.amount &&
      charge?.isReceivable &&
      !charge.isFullyPaid()
    ) {
      status = `${this.trans('status-to-receive')}`;
    } else if (charge.isFullyPaid() && charge?.isReceivable) {
      status = `${this.trans('status-received')}`;
    } else if (charge.isFullyPaid() && charge?.isPayable) {
      status = `${this.trans('status-amount/paid')}`;
    } else {
      status = '';
    }

    return (
      <span
        style={{
          fontSize: '11px',
          color: '#80808091',
        }}
      >
        {status}
      </span>
    );
  };

  public getCharges = (
    charges: ChargeInterface[],
    selectedChargesRows: number[],
    callback: any
  ): any => {
    return charges.map((charge: ChargeInterface, index: number) => {
      if (!charge) {
        return;
      }

      const shouldShowPaidDate = !!charge.oldestPaymentDate;
      const isItemSelected = selectedChargesRows.includes(index);
      const labelId = `enhanced-table-checkbox-${index}`;

      return (
        <TableRow
          hover
          key={`charge-${charge.id}`}
          // onClick={() => {
          //   this.saveDetailsBeforeRedirect(`chargeUpdate-${this.state.charge?.id}-`);

          //   this.redirect(`/app/charge/update/${charge?.id}`);
          // }}
          role="checkbox"
          aria-checked={isItemSelected}
          selected={isItemSelected}
        >
          <TableCell
            padding="checkbox"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              callback(event, [index]);
            }}
          >
            <Checkbox
              checked={isItemSelected}
              inputProps={{ 'aria-labelledby': labelId }}
              color="primary"
            />
          </TableCell>
          <TableCell
            style={{ width: '24px', paddingLeft: '10px', paddingRight: '5px' }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: '4px',
              }}
            >
              <div
                style={{ color: charge.getIconColor() }}
                className="icon icon-ic-charge"
              ></div>
            </div>
          </TableCell>
          <TableCell style={{ width: '100px', maxWidth: '100px' }}>
            {shouldShowPaidDate && (
              <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
                <span>{this.formatter.formatDate(charge.orderDate)}</span>
                <span
                  style={{ fontSize: '12px', color: 'gray' }}
                >{`${this.trans(
                  'status-paid'
                ).toLowerCase()}: ${this.formatter.formatDate(
                  charge.oldestPaymentDate
                )}`}</span>
              </div>
            )}
            {!shouldShowPaidDate && (
              <span>{this.formatter.formatDate(charge.orderDate)}</span>
            )}
          </TableCell>
          <TableCell>
            <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                {charge?.name || ''}
                {charge.creationTypeDisplayName && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '2px 0px 0px 5px',
                    }}
                  >
                    <div className="list-label creation-type-label">
                      {charge.creationTypeDisplayName}
                    </div>
                  </div>
                )}
              </div>
              <span style={{ fontSize: '12px', color: 'gray' }}>
                {`${
                  charge && charge.description === ''
                    ? Formatter.checkTranslationType(
                        this.trans(
                          charge?.type?.label,
                          {},
                          '',
                          charge?.type?.system
                        ),
                        charge?.type?.label,
                        charge?.type?.system
                      ) +
                      ',' +
                      Formatter.monthFullFormatDate(charge.firstDate)
                    : charge.description
                } ${
                  !!charge.relatedEntity
                    ? '- ' + charge.relatedEntity.displayName
                    : ''
                }`}
              </span>
            </div>
          </TableCell>
          <TableCell style={{ textAlign: 'right', width: '28%' }}>
            {
              <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
                <span>
                  {charge.chargeClass.id ==
                    ChargeClassContainer.pickIdFromLabel('Payable') &&
                    charge?.amount > 0 && (
                      <span className="minus-style">{'-'}</span>
                    )}
                  {this.formatter.formatNumber(charge.amount, charge.currency)}
                </span>
                {this.renderChargeAmountHint(charge)}
              </div>
            }
          </TableCell>
        </TableRow>
      );
    });
  };

  public onDirectInDirectChargeRowSelection = (
    _event,
    rows: number[]
  ): void => {
    let charges: ChargeInterface[];
    let chargesIds: number[];
    let charge = null;

    charges = rows.map((row) => {
      return this.state.directIndirectCharges[row];
    });

    chargesIds = rows.map((row) => {
      return this.state.directIndirectCharges[row].id;
    });

    if (!!charges && charges.length > 0) {
      charge = charges[0];
    }

    // if there are charges selected in the other list first we should clear them
    if (this.state.selectedObjectChargesRows.length > 0) {
      this.setState(
        {
          selectedObjectChargesRows: [],
          chargeIds: [],
        },
        () => {
          // if user click on selected charge
          // if selectRows === rows in our state, we clear this field(unselect), otherwise we set selected row.
          if (this.state.selectedDirectIndirectChargesRows[0] === rows[0]) {
            this.setState({
              selectedDirectIndirectChargesRows: [],
              chargeIds: [],
              selectedCharge: null,
            });
          } else {
            this.setState({
              selectedDirectIndirectChargesRows: rows,
              chargeIds: chargesIds,
              selectedCharge: charge,
            });
          }
        }
      );
    } else {
      if (this.state.selectedDirectIndirectChargesRows[0] === rows[0]) {
        this.setState({
          selectedDirectIndirectChargesRows: [],
          chargeIds: [],
          selectedCharge: null,
        });
      } else {
        this.setState({
          selectedDirectIndirectChargesRows: rows,
          chargeIds: chargesIds,
          selectedCharge: charge,
        });
      }
    }
  };

  public onObjectChargeRowSelection = (_event, rows: number[]): void => {
    let charges: ChargeInterface[];
    let chargesIds: number[];
    let charge = null;

    charges = rows.map((row) => {
      return this.state.objectCharges[row];
    });

    chargesIds = rows.map((row) => {
      return this.state.objectCharges[row].id;
    });

    if (!!charges && charges.length > 0) {
      charge = charges[0];
    }

    // if there are charges selected in the other list first we should clear them
    if (this.state.selectedDirectIndirectChargesRows.length > 0) {
      this.setState(
        {
          selectedDirectIndirectChargesRows: [],
          chargeIds: [],
        },
        () => {
          // if user click on selected charge
          // if selectRows === rows in our state, we clear this field(unselect), otherwise we set selected row.
          if (this.state.selectedObjectChargesRows[0] === rows[0]) {
            this.setState({
              selectedObjectChargesRows: [],
              chargeIds: [],
              selectedCharge: null,
            });
          } else {
            this.setState({
              selectedObjectChargesRows: rows,
              chargeIds: chargesIds,
              selectedCharge: charge,
            });
          }
        }
      );
    } else {
      if (this.state.selectedObjectChargesRows[0] === rows[0]) {
        this.setState({
          selectedObjectChargesRows: [],
          chargeIds: [],
          selectedCharge: null,
        });
      } else {
        this.setState({
          selectedObjectChargesRows: rows,
          chargeIds: chargesIds,
          selectedCharge: charge,
        });
      }
    }
  };

  public selectEntityForExistingCharge = (
    entity: PropertyInterface | UnitInterface | ContractInterface
  ): void => {
    this.setState(
      {
        selectedEntityForExistingCharge: entity,
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [],
        chargeIds: [],
      },
      () => {
        // after selecting an object should fetch charges related to this object
        this.fetchExistingCharges();
      }
    );
  };

  public clearEntityForExistingCharge = (): void => {
    this.setState({
      selectedEntityForExistingCharge: null,
      selectedDirectIndirectChargesRows: [],
      selectedObjectChargesRows: [],
      chargeIds: [],
    });
  };



  public settleWithSavingsCheckScenario = () => {
    this.setState({
      isSaving: true,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_START,
      payload: {
        chargeId: this.state?.charge?.id,
      },
      onSuccess: (scenario) => {
        if (typeof scenario === 'string') {
          this.setState({
            isChargeSettleWithSavingsPopupOpen: true,
            settleSavingScenarioMessage: scenario,
          });
        }
        this.setState({
          isSaving: false,
        });
      },
      onError: () => {
        this.setState({
          isSaving: false,
          settleSavingScenarioMessage:
            'it_is_not_possible_to_make_savings_action',
        });
      },
    });
  };

  public getSavingsAmount = () => {
    if (!this.state.charge) return 0; // cover first render before charge is loaded
    const companies = this.props.app.companies;
    const company = companies.find((company: CompanyInterface) => company.id === this.state.charge.ownerId);
    return company?.data?.savingsAccount ?? 0;
  }

  public insufficientSavingsForRemainingAmount = () => {
    const charge = this.state.charge;
    return this.getSavingsAmount() - charge.amountRemaining < 0;
  }

  // Do not allow a settlement with savings, if the savings amount is not sufficient
  // Only relevent for scenarios in which money is to be withdrawn from the savings account:
  // 1. money to be received from owner or agency
  // 2. money to be paid by owner or agency
  // In other scenarios, the settlement popup will be shown after clicking on settle 
  public checkSavingsBeforeSettling = () => {
    const charge = this.state.charge;
    if ( 
      (charge.isReceivable && charge.hasOwnerAsObject && charge.isCounterpartyOwner) || // money to be received from the owner (example: payout charge)
      (charge.isPayable && charge.hasOwnerAsObject && !charge.isCounterpartyOwner) ||  // money to be paid by the owner to the agency or 3rd party 
      (charge.isReceivable && charge.hasAgencyAsObject && charge.isCounterpartyAgency) || // money to be received from the agency (example: payout charge)
      (charge.isPayable && charge.hasAgencyAsObject && !charge.isCounterpartyAgency) // money to be paid by the agency to a 3rd party (an owner cannot be the counterparty because when an owner is involved that owner is always the object of the charge)
    ) { 
      if (this.insufficientSavingsForRemainingAmount()) this.setState({ isNegativeAmountPopupOpen: true, });
      else this.settleWithSavingsCheckScenario()
    } else this.settleWithSavingsCheckScenario();
}

  public unrefundCharge = (): void => {
    const charge: ChargeInterface = this.state.charge;

    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_UNREFUND_START,
          payload: {
            charge: charge,
          },
          onSuccess: () => {
            this.initializePage(this.state.charge?.id);
          },
          onError: () => {
            this.setState({
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public undoCredit = (): void => {
    const charge: ChargeInterface = [
      this.state.chargeToUncredit,
      this.state.charge,
    ].find((charge) => charge?.isCredit);
    const linkedChargeId = charge?.linkedChargeId;

    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_UNDO_CREDIT_START,
          payload: {
            charge: charge,
          },
          onSuccess: () => {
            if (this.state.charge?.isCredit && linkedChargeId) {
              return this.redirect(`/app/charge/update/${linkedChargeId}`);
            }
            this.initializePage(this.state.charge?.id);
          },
          onError: () => {
            this.setState({
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public undoWithdrawal = (): void => {
    const charge: ChargeInterface = this.state.charge;

    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_START,
          payload: {
            chargeId: charge?.id,
          },
          onSuccess: () => {
            this.initializePage(this.state.charge?.id);
          },
          onError: () => {
            this.setState({
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public undoDeposit = (): void => {
    const charge: ChargeInterface = this.state.charge;
    this.setState(
      { isSaving: true, },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_UNDO_DEPOSIT_FROM_SAVINGS_ACCOUNT_START,
          payload: { chargeId: charge?.id, },
          onSuccess: () => { this.initializePage(this.state.charge?.id); },
          onError: () => {this.setState({ isSaving: false, });},
        });
      }
    );
  };

  public createInvoicePdf = (type: string, callback?): void => {
    this.setState(
      {
        isSaving: true,
      },
      () => {
        let languageId;
        if (type === 'chargeDetails') {
          if (this.state?.charge?.counterparty instanceof Person) {
            languageId = this.state?.charge?.counterparty?.languageTypeId;
          }
          if (this.state?.charge?.counterparty instanceof Company) {
            languageId =
              this.state?.charge?.counterparty?.generalContact?.languageTypeId;
          }
        } else {
          languageId =
            this.props.app?.settings?.agency?.defaultLocale?.iso === 'en-US'
              ? 1
              : 2;
        }
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_CREATE_INVOICE_START,
          payload: {
            chargeId: this.state.charge?.id,
            templateType: type,
            isCredit: this.state.charge?.isCreditType,
            // Fallback in case languageId is not valid
            lngId: languageId
              ? languageId
              : this.props.app?.settings?.agency?.defaultLocale?.iso === 'en-US'
              ? 1
              : 2,
          },
          onSuccess: () => {
            if (typeof callback === 'function') {
              callback();
            }
          },
          onError: () => {
            this.setState({
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public createCredit = (): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_START,
        payload: {
          charge: this.state.charge,
          amount: parseFloat(
            parseFloat(
              String(
                Formatter.deleteExtraSpace(this.state.createCreditProcessAmount)
              ).replace(',', '.')
            ).toFixed(2)
          ),
          description: this.state.createCreditProcessDescription,
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
          });

          this.initializePage(this.state.charge?.id);
        },
        onError: () => {
          this.setState({
            isSaving: false,
            anchorEl: null,
          });
        },
      });
    });
  };

  public setPaidDirectlyToOwner = (): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_PAID_TO_OWNER_START,
        payload: {
          charge: this.state.charge,
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
          });

          this.initializePage(this.state.charge?.id);
        },
        onError: () => {
          this.setState({
            isSaving: false,
            anchorEl: null,
          });
        },
      });
    });
  };

  public render() {
    const payment = this.state.linkedPayments.find(
      (payment: PaymentInterface) => payment.isPaidDirectlyToOwner === true
    );
    const isLocked = !!this.state.charge ? this.state.charge.isLocked : false;
    const isRemoved = !!this.state.charge ? this.state.charge.removed : false;
    // CASA-10321: Order was always random because we setstate without async/await. Had to implement ordering logic
    const orderedSettledCharges = this.state.settledChargeIds?.map((id) =>
      this.state.settledCharges.find((obj) => obj?.charge?.id === id)
    );

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button align-center">
            <div
              className="inner-wrapper"
              style={{ justifyContent: 'space-between' }}
            >
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper">
                <h1 style={{ display: 'flex', alignItems: 'center' }}>
                  {this.trans('page/chargeupdate-title')}
                </h1>
              </div>
              {this.state.renderDetails && this.state.charge?.isReceivable && (
                <div style={{ marginLeft: '20px' }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.isSent}
                        onChange={this.changeChargeSentStatus.bind(
                          this,
                          this.state.charge
                        )}
                        color="primary"
                      />
                    }
                    label={this.trans('status-sent')}
                  />
                </div>
              )}
              <div className="button-container">
                {this.hasModifiedData() && (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.save}
                    style={{ marginRight: '20px' }}
                  >
                    {this.trans('page/entity-button/save')}
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.redirectBack}
                  disabled={this.state.isSaving}
                >
                  {this.trans('button-close')}
                </Button>
              </div>
            </div>
          </div>

          <div>
            <div className="box component-charge-update">
              {this.state.renderDetails && (
                <>
                  <div className="component-wrapper no-margin-top">
                    <div className="component">
                      {this.state.isFetchingCharge ? (
                        <div style={{ position: 'relative', height: '60px' }}>
                          <div className="component-spinner-wrapper">
                            <CircularProgress />
                          </div>
                        </div>
                      ) : (
                        <Charge2Card
                          {...this.props}
                          relatedCharge={this.state?.relatedCharge}
                          initializePage={this.initializePage}
                          isSummaryView={false}
                          chargePayments={this.state.linkedPayments}
                          hideChargeChoice={true}
                          chargeChoice={this.state.chargeChoice}
                          sectionTitle={this.trans('section/charge-title')}
                          hideNoChargeOption={true}
                          amountForCharge={this.state.amountForCharge}
                          invoiceDateForCharge={this.state.invoiceDateForCharge}
                          invoiceNumberForCharge={
                            this.state.invoiceNumberForCharge
                          }
                          vatForCharge={this.state.vatForCharge}
                          vatPercentageForCharge={
                            this.state.vatPercentageForCharge
                          }
                          isInvoice={this.state.isInvoice}
                          currencyIdForCharge={this.state.currencyIdForCharge}
                          showChargeOwnerChoice={
                            this.state.showChargeOwnerChoice
                          }
                          chargeOwnerChoice={this.state.chargeOwnerChoice}
                          selectedPersonForCharge={
                            this.state.selectedPersonForCharge
                          }
                          selectedCompanyForCharge={
                            this.state.selectedCompanyForCharge
                          }
                          typeIdForCharge={this.state.typeIdForCharge}
                          selectedEntityForCharge={
                            this.state.selectedEntityForCharge
                          }
                          periodForCharge={this.state.periodForCharge}
                          firstDateForCharge={this.state.firstDateForCharge}
                          dateOfPeriodForCharge={
                            this.state.dateOfPeriodForCharge
                          }
                          descriptionForCharge={this.state.descriptionForCharge}
                          descriptionForChargeIsManuallyChanged={
                            this.state.descriptionForChargeIsManuallyChanged
                          }
                          chargeClassId={this.state.chargeClassId}
                          isSettle={this.state.isSettle}
                          hasSettlementType={this.state.hasSettlementType}
                          hasSavingsType={this.state.hasSavingsType}
                          isLocked={isLocked}
                          isRemoved={isRemoved}
                          charge={this.state.charge}
                          pageName="chargeupdate"
                          withoutTabs={true}
                          showInvoiceSwitch={true}
                          handleChangeIsInvoice={this.handleChangeIsInvoice}
                          financialStatement={this.state.financialStatement}
                          financialStatementPeriodMinDate={
                            this.state.financialStatementPeriodMinDate
                          }
                          attachments={this.state.attachments}
                          amazonFolderName={this.state.amazonFolderName}
                          renderDetails={this.state.renderDetails}
                          isFetchingCharge={this.state.isFetchingCharge}
                          updateParentState={(attachments) =>
                            this.setState({ attachments: attachments })
                          }
                          selectDate={this.selectDate}
                          changeAmountForCharge={this.changeAmountForCharge}
                          changeInvoiceNumberForCharge={
                            this.changeInvoiceNumberForCharge
                          }
                          changeVatForCharge={this.changeVatForCharge}
                          changeVatPercentageForCharge={
                            this.changeVatPercentageForCharge
                          }
                          changeCurrencyIdForCharge={
                            this.changeCurrencyIdForCharge
                          }
                          changeChargeOwnerChoice={this.changeChargeOwnerChoice}
                          selectPersonForCharge={this.selectPersonForCharge}
                          clearPersonForCharge={this.clearPersonForCharge}
                          selectCompanyForCharge={this.selectCompanyForCharge}
                          clearCompanyForCharge={this.clearCompanyForCharge}
                          changeTypeIdForCharge={this.changeTypeIdForCharge}
                          selectEntityForCharge={this.selectEntityForCharge}
                          clearEntityForCharge={this.clearEntityForCharge}
                          changePeriodForCharge={this.changePeriodForCharge}
                          changeDescriptionForCharge={
                            this.changeDescriptionForCharge
                          }
                          isCreateChargeTypePopupOpen={
                            this.state.isCreateChargeTypePopupOpen
                          }
                          addChargeType={this.addChargeType}
                          renderChargeType={this.state.typeIdForCharge}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(
                            this,
                            `chargeUpdate-${this.state.charge?.id}-`
                          )}
                          autoFocusAmount={true}
                          mainCardPresentation={true}
                          newCounterpartyLookup={true}
                          selectCounterpartyForCharge={
                            this.selectCounterpartyForCharge
                          }
                          clearCounterpartyForCharge={
                            this.clearCounterpartyForCharge
                          }
                          selectedCounterpartyForCharge={
                            this.state.selectedCounterpartyForCharge
                          }
                          openEditableView={this.openEditableView}
                          isEditableView={this.state.isEditableView}
                        />
                      )}
                    </div>
                  </div>

                  {/* {
                  this.state.showHintBox && this.state.charge && this.state.charge?.automaticallyLinked && this.state.linkedPayments.length > 0 &&
                    <div className="component-wrapper no-margin-top">
                      <Card className="card" style={{padding: "20px", backgroundColor: "#FDFFEC"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div className="icon icon-ic-info"></div>
                          <div style={{marginLeft: "12px"}}>
                            Is this charge linked with correct payment?
                          </div>
                        </div>
                        <div style={{
                          marginTop: "12px",
                          display: "flex",
                          justifyContent: "flex-end"

                        }}>
                          <Button
                            variant="outlined"
                            style={{
                              color: "#F44336",
                              borderColor: "#F44336",
                              marginRight: "12px"
                            }}
                          >
                            No
                          </Button>
                          <Button
                            variant="outlined"
                            color="primary"
                          >
                            Yes
                          </Button>
                        </div>
                      </Card>
                    </div>
                  } */}
                  {/* {
                  this.state.showHintBox && this.state.charge && !this.state.linkedPayments.length && this.state.directIndirectPayments.length > 0 &&
                    <div className="component-wrapper no-margin-top">
                      <Card className="card" style={{padding: "20px", backgroundColor: "#FDFFEC"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div className="icon icon-ic-info"></div>
                          <div style={{marginLeft: "12px"}}>
                            Our system found some potential matching payments to link with this charge.
                            Is any of them are what you looking for?
                          </div>
                        </div>
                        <div style={{
                          marginTop: "12px",
                          display: "flex",
                          justifyContent: "flex-end"

                        }}>
                          <Button
                            variant="outlined"
                            style={{
                              color: "#F44336",
                              borderColor: "#F44336",
                              marginRight: "12px"
                            }}
                          >
                            No
                          </Button>
                          <Button
                            variant="outlined"
                            color="primary"
                          >
                            Yes
                          </Button>
                        </div>
                      </Card>
                    </div>
                  }
                  {
                  this.state.showHintBox && this.state.charge && !this.state.linkedPayments.length && !this.state.directIndirectPayments.length &&
                    <div className="component-wrapper no-margin-top">
                      <Card className="card" style={{padding: "20px", backgroundColor: "#FDFFEC"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div className="icon icon-ic-info"></div>
                          <div style={{marginLeft: "12px"}}>
                            Our system couldn't find any potentially matching payments.
                            Please search the payment by yourself or click "Create" to create a new payment.
                          </div>
                        </div>
                        <div style={{
                          marginTop: "12px",
                          display: "flex",
                          justifyContent: "flex-end"

                        }}>
                          <Button
                            variant="contained"
                            color="primary"
                            style={{
                              marginRight: "12px"
                            }}
                          >
                            Got it
                          </Button>
                          <Button
                            variant="outlined"
                            color="primary"
                          >
                            Create
                          </Button>
                        </div>
                      </Card>
                    </div>
                  } */}
                </>
              )}

              <div style={{ padding: '0 30px' }}>
                {/* {
                  this.state.charge && this.state.relatedCharge &&
                  <div className="link-info">
                    <div>|</div>
                    <div>{this.trans("page/paymentchargeupdate-label/relatedto")}</div>
                    <div>|</div>
                  </div>
                }

                {
                  this.state.charge && this.state.relatedCharge &&
                  <div className="component-wrapper">
                    <div className="component">
                      <Charge2Card
                        {...this.props}
                        charge={this.state?.relatedCharge}
                        key={`charge-${this.state?.relatedCharge?.id}`}
                        unActionButton={
                          <Button
                            variant="outlined"
                            style={{color: "#F44336", borderColor: "#F44336"}}
                            onClick={() => {
                              if (this.checkProcessIsBusy({
                                                action: "unsettle",
                                                entityName: "charge",
                                                entity: this.state.charge
                                              })) {
                                this.openIsBusyPopup();
                                this.setState({anchorElCharge: null})
                              } else {
                                this.setState({
                                  // isChargeUnSettlePopupOpen: true,
                                  // chargeIdToUnsettle: chargeData?.charge?.id,
                                  anchorElCharge: null
                                })
                              }
                            }}
                          >
                            {this.trans("button-unlink")}
                          </Button>
                        }
                      />
                    </div>
                  </div>
                } */}

                {/* {
                  this.state.charge && this.state.relatedPayments && this.state.relatedPayments.length > 0 &&
                  this.state.relatedPayments.filter((payment: PaymentInterface) => !payment.hasSettlementType)?.reverse()?.map((payment: PaymentInterface) => {
                    return (
                        <div className="component-wrapper">
                          <div className="component">
                          <Payment2Card
                            {...this.props}
                            key={`payment-${payment?.id}`}
                            payment={payment}
                            linkedCharge={this.state.charge}
                            paymentIdForDetailsPresentation={this.state.paymentIdForDetailsPresentation}
                            changeSettledIdForDetailsPresentation={id => this.setState({settledChargeIdForDetailsPresentation: id})}
                            changePaymentIdForDetailsPresentation={id => this.setState({paymentIdForDetailsPresentation: id})}
                            onPressOpenFromChargePage={() => {
                              this.props.dispatch({
                                type: Constants.OPEN_PAYMENT_CARD_ON_DETAILED_VIEW,
                              })
                            }}
                            newCardStyles={true}
                            unActionButton={
                              payment.isRefunded ?
                              <Button
                                variant="outlined"
                                style={{color: "#F44336", borderColor: "#F44336"}}
                                onClick={() => {
                                  if (this.checkProcessIsBusy({
                                                    action: "unrefund",
                                                    entityName: "charge",
                                                    entity: this.state.charge
                                                  })) {
                                    this.openIsBusyPopup();
                                    this.setState({anchorEl: null})
                                  } else {
                                    this.setState({
                                      isChargeUnrefundPopupOpen: true,
                                      paymentToDelete: payment,
                                      anchorEl: null
                                    })
                                  }
                                }}
                              >
                                {this.trans("menu/charge-option/unrefund")}
                              </Button>
                              :
                              <Button
                                variant="outlined"
                                style={{color: "#F44336", borderColor: "#F44336"}}
                                onClick={() => {
                                  if (this.checkProcessIsBusy({
                                                    action: "unlink",
                                                    entityName: "charge",
                                                    entity: this.state.charge
                                                  })) {
                                    this.openIsBusyPopup();
                                    this.setState({anchorEl: null})
                                  } else {
                                    this.setState({
                                      isPaymentUnlinkPopupOpen: true,
                                      paymentToDelete: payment,
                                      anchorEl: null
                                    })
                                  }
                                }}
                              >
                                {this.trans("button-unlink")}
                              </Button>
                            }
                          />
                        </div>
                      </div>
                    );
                  })
                } */}
                {this.state.charge &&
                  this.state.linkedPayments &&
                  this.state.linkedPayments.filter(
                    (payment: PaymentInterface) => !payment.hasSettlementType
                  ).length > 0 && (
                    <div className="link-info">
                      <div>|</div>
                      <div>{this.trans('page/chargeupdate-label/paidby')}</div>
                      <div>|</div>
                    </div>
                  )}

                {this.state.charge &&
                  this.state.linkedPayments &&
                  this.state.linkedPayments.length > 0 &&
                  this.state.linkedPayments
                    .filter(
                      (payment: PaymentInterface) => !payment.hasSettlementType
                    )
                    ?.reverse()
                    ?.map((payment: PaymentInterface) => {
                      const showUnlinkButton = !(
                        payment?.paymentType?.id ===
                        PaymentTypeContainer.pickIdFromLabel('Savings_account')
                      );
                      const settlementAmount =
                        payment.amountDetails[this.state.charge.id];
                      return (
                        <div className="component-wrapper">
                          <div className="component">
                            <Payment2Card
                              {...this.props}
                              key={`payment-${payment?.id}`}
                              payment={payment}
                              isSettled={true}
                              settlementAmount={settlementAmount}
                              linkedCharge={this.state.charge}
                              paymentIdForDetailsPresentation={
                                this.state.paymentIdForDetailsPresentation
                              }
                              changeSettledIdForDetailsPresentation={(id) =>
                                this.setState({
                                  settledChargeIdForDetailsPresentation: id,
                                })
                              }
                              changePaymentIdForDetailsPresentation={(id) =>
                                this.setState({
                                  paymentIdForDetailsPresentation: id,
                                })
                              }
                              onPressOpenFromChargePage={() => {
                                this.props.dispatch({
                                  type: Constants.OPEN_PAYMENT_CARD_ON_DETAILED_VIEW,
                                });
                              }}
                              newCardStyles={true}
                              unActionButton={
                                payment.isRefunded ? (
                                  <Button
                                    variant="outlined"
                                    style={{
                                      color: '#F44336',
                                      borderColor: '#F44336',
                                    }}
                                    onClick={() => {
                                      if (
                                        this.checkProcessIsBusy({
                                          action: 'unrefund',
                                          entityName: 'charge',
                                          entity: this.state.charge,
                                        })
                                      ) {
                                        this.openIsBusyPopup();
                                        this.setState({ anchorEl: null });
                                      } else {
                                        this.setState({
                                          isChargeUnrefundPopupOpen: true,
                                          paymentToDelete: payment,
                                          anchorEl: null,
                                        });
                                      }
                                    }}
                                  >
                                    {this.trans('menu/charge-option/unrefund')}
                                  </Button>
                                ) : showUnlinkButton ? (
                                  <Button
                                    variant="outlined"
                                    style={{
                                      color: '#F44336',
                                      borderColor: '#F44336',
                                    }}
                                    onClick={() => {
                                      if (
                                        this.checkProcessIsBusy({
                                          action: 'unlink',
                                          entityName: 'charge',
                                          entity: this.state.charge,
                                        })
                                      ) {
                                        this.openIsBusyPopup();
                                        this.setState({ anchorEl: null });
                                      } else {
                                        this.setState({
                                          isPaymentUnlinkPopupOpen: true,
                                          paymentToDelete: payment,
                                          anchorEl: null,
                                        });
                                      }
                                    }}
                                  >
                                    {this.trans('button-unlink')}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outlined"
                                    style={{
                                      color: '#F44336',
                                      borderColor: '#F44336',
                                    }}
                                    onClick={() => {
                                      if (
                                        this.checkProcessIsBusy({
                                          action: 'unlink',
                                          entityName: 'charge',
                                          entity: this.state.charge,
                                        })
                                      ) {
                                        this.openIsBusyPopup();
                                        this.setState({ anchorEl: null });
                                      } else {
                                        this.setState({
                                          isUndoSavingsPopupOpen: true,
                                          anchorEl: null,
                                        });
                                      }
                                    }}
                                  >
                                    {this.trans('button-unsettle')}
                                  </Button>
                                )
                              }
                            />
                          </div>
                        </div>
                      );
                    })}

                {orderedSettledCharges?.length > 0 && (
                  <div className="link-info">
                    <div>|</div>
                    <div>
                      {this.trans('page/chargeupdate-label/settledwith')}
                    </div>
                    <div>|</div>
                  </div>
                )}

                {orderedSettledCharges?.map((chargeData) => {
                  const showUnlinkButton =
                    !this.state.charge?.isCreditType &&
                    !chargeData?.charge?.isCreditType;
                  const settlementPayment = this.state.linkedPayments.find(
                    (payment: PaymentInterface) =>
                      payment.isSettle &&
                      Object.keys(payment.amountDetails).includes(
                        String(chargeData?.charge.id)
                      )
                  );
                  const settlementAmount = settlementPayment?.amount;
                  return (
                    <div className="component-wrapper">
                      <div className="component">
                        <Charge2Card
                          {...this.props}
                          key={`charge-${chargeData?.charge?.id}`}
                          charge={chargeData?.charge}
                          isSettled={true}
                          settlementAmount={settlementAmount}
                          linkedCharge={this.state.charge}
                          // settledChargeIdForDetailsPresentation={this.state.settledChargeIdForDetailsPresentation}
                          // changeSettledIdForDetailsPresentation={id => this.setState({settledChargeIdForDetailsPresentation: id})}
                          // changePaymentIdForDetailsPresentation={id => this.setState({paymentIdForDetailsPresentation: id})}
                          unActionButton={
                            showUnlinkButton ? (
                              <Button
                                variant="outlined"
                                style={{
                                  color: '#F44336',
                                  borderColor: '#F44336',
                                }}
                                onClick={() => {
                                  if (
                                    this.checkProcessIsBusy({
                                      action: 'unsettle',
                                      entityName: 'charge',
                                      entity: this.state.charge,
                                    })
                                  ) {
                                    this.openIsBusyPopup();
                                    this.setState({ anchorElCharge: null });
                                  } else {
                                    this.setState({
                                      isChargeUnSettlePopupOpen: true,
                                      chargeIdToUnsettle:
                                        chargeData?.charge?.id,
                                      anchorElCharge: null,
                                    });
                                  }
                                }}
                              >
                                {this.trans('button-unsettle')}
                              </Button>
                            ) : (
                              <Button
                                variant="outlined"
                                style={{
                                  color: '#F44336',
                                  borderColor: '#F44336',
                                }}
                                onClick={() => {
                                  if (
                                    this.checkProcessIsBusy({
                                      action: 'uncredit',
                                      entityName: 'charge',
                                      entity: this.state.charge,
                                    })
                                  ) {
                                    this.openIsBusyPopup();
                                    this.setState({ anchorElCharge: null });
                                  } else {
                                    this.setState({
                                      isUndoCreditPopupOpen: true,
                                      chargeToUncredit: chargeData?.charge,
                                      anchorElCharge: null,
                                    });
                                  }
                                }}
                              >
                                {this.trans(
                                  'page/chargeupdate-preprocess/unrefund-button'
                                )}
                              </Button>
                            )
                          }
                        />
                      </div>
                    </div>
                  );
                })}

                {this.state.charge?.amountRemaining > 0 &&
                  !this.state.charge.removed && (
                    <div
                      className="component-wrapper"
                      style={{
                        marginTop: '20px',
                      }}
                    >
                      <div className="component">
                        <Payments2List
                          {...this.props}
                          hidePaymentChoice={false}
                          hideNoPaymentOption={false}
                          paymentChoice={this.state.paymentChoice}
                          showPayerChoice={this.state.showPayerChoice}
                          amountForPayment={this.state.amountForPayment}
                          currencyIdForPayment={this.state.currencyIdForPayment}
                          firstDateOfStatementPeriodForPayment={
                            this.state.firstDateOfStatementPeriodForPayment
                          }
                          dateOfThePayment={this.state.dateOfThePayment}
                          typeIdForPayment={this.state.typeIdForPayment}
                          agencyBankAccountIdForPayment={
                            this.state.agencyBankAccountIdForPayment
                          }
                          counterpartyIbanForPayment={
                            this.state.counterpartyIbanForPayment
                          }
                          originalCounterpartyIban={
                            this.state.originalCounterpartyIban
                          }
                          counterpartyIbanForPaymentIsManuallyChanged={
                            this.state
                              .counterpartyIbanForPaymentIsManuallyChanged
                          }
                          paymentClassId={this.state.paymentClassId}
                          payerChoice={this.state.payerChoice}
                          selectedPersonForPayment={
                            this.state.selectedPersonForPayment
                          }
                          selectedCompanyForPayment={
                            this.state.selectedCompanyForPayment
                          }
                          descriptionForPayment={
                            this.state.descriptionForPayment
                          }
                          descriptionForPaymentIsManuallyChanged={
                            this.state.descriptionForPaymentIsManuallyChanged
                          }
                          directIndirectPayments={
                            this.state.directIndirectPayments
                          }
                          selectedDirectIndirectPaymentsRows={
                            this.state.selectedDirectIndirectPaymentsRows
                          }
                          payerPayments={this.state.payerPayments}
                          selectedPayerPaymentsRows={
                            this.state.selectedPayerPaymentsRows
                          }
                          selectedPersonForExistingPayments={
                            this.state.selectedPersonForExistingPayments
                          }
                          selectedCompanyForExistingPayments={
                            this.state.selectedCompanyForExistingPayments
                          }
                          existingPayerChoice={this.state.existingPayerChoice}
                          scrollToEndOfPage={true}
                          selectedPersonForExistingCharges={
                            this.state.selectedPersonForExistingCharges
                          }
                          selectedCompanyForExistingCharges={
                            this.state.selectedCompanyForExistingCharges
                          }
                          existingChargesPayerChoice={
                            this.state.existingChargesPayerChoice
                          }
                          openCreateBankAccountPopup={
                            this.openCreateBankAccountPopup
                          }
                          changePaymentChoiceView={this.changePaymentChoiceView}
                          selectDate={this.selectDate}
                          changeAmountForPayment={this.changeAmountForPayment}
                          changeCurrencyIdForPayment={
                            this.changeCurrencyIdForPayment
                          }
                          changePayerChoice={this.changePayerChoice}
                          selectPersonForPayment={this.selectPersonForPayment}
                          clearPersonForPayment={this.clearPersonForPayment}
                          selectCompanyForPayment={this.selectCompanyForPayment}
                          clearCompanyForPayment={this.clearCompanyForPayment}
                          changePaymentClassId={this.changePaymentClassId}
                          changeTypeIdForPayment={this.changeTypeIdForPayment}
                          updateAgencyBankAccountIdForPayment={
                            this.updateAgencyBankAccountIdForPayment
                          }
                          changeCounterpartyIbanForPayment={
                            this.changeCounterpartyIbanForPayment
                          }
                          changeDescriptionForPayment={
                            this.changeDescriptionForPayment
                          }
                          getPayments={this.getPayments}
                          onDirectIndirectPaymentRowSelection={
                            this.onDirectInDirectPaymentRowSelection
                          }
                          onPayerPaymentRowSelection={
                            this.onPayerPaymentRowSelection
                          }
                          selectPersonForExistingPayments={
                            this.selectPersonForExistingPayments
                          }
                          clearPersonForExistingPayments={
                            this.clearPersonForExistingPayments
                          }
                          selectCompanyForExistingPayments={
                            this.selectCompanyForExistingPayments
                          }
                          clearCompanyForExistingPayments={
                            this.clearCompanyForExistingPayments
                          }
                          changeExistingPayerChoice={
                            this.changeExistingPayerChoice
                          }
                          selectPersonForExistingCharges={
                            this.selectPersonForExistingCharges
                          }
                          clearPersonForExistingCharges={
                            this.clearPersonForExistingCharges
                          }
                          selectCompanyForExistingCharges={
                            this.selectCompanyForExistingCharges
                          }
                          clearCompanyForExistingCharges={
                            this.clearCompanyForExistingCharges
                          }
                          changeExistingChargesPayerChoice={
                            this.changeExistingChargesPayerChoice
                          }
                          saveDetailsBeforeRedirect={
                            this.state.payerChoice === 'person'
                              ? this.saveDetailsBeforeRedirect.bind(this, [
                                  `chargeUpdate-${this.state.charge?.id}-`,
                                  'personCreate',
                                ])
                              : this.saveDetailsBeforeRedirect.bind(this, [
                                  `chargeUpdate-${this.state.charge?.id}-`,
                                  'companyCreate',
                                ])
                          }
                          directIndirectCharges={
                            this.state.directIndirectCharges
                          }
                          selectedDirectIndirectChargesRows={
                            this.state.selectedDirectIndirectChargesRows
                          }
                          objectCharges={this.state.objectCharges}
                          selectedObjectChargesRows={
                            this.state.selectedObjectChargesRows
                          }
                          selectedEntityForExistingCharge={
                            this.state.selectedEntityForExistingCharge
                          }
                          getCharges={this.getCharges}
                          onDirectInDirectChargeRowSelection={
                            this.onDirectInDirectChargeRowSelection
                          }
                          onObjectChargeRowSelection={
                            this.onObjectChargeRowSelection
                          }
                          selectEntityForExistingCharge={
                            this.selectEntityForExistingCharge
                          }
                          clearEntityForExistingCharge={
                            this.clearEntityForExistingCharge
                          }
                          paymentSearchInProgress={
                            this.state.paymentSearchInProgress
                          }
                          updatePaymentSearchString={
                            this.updatePaymentSearchString
                          }
                        />
                      </div>
                    </div>
                  )}
              </div>
            </div>

            <div className={'right-panel-wrapper'}>
              {!isRemoved && this.state.showLaunchPanel && (
                <EntityLaunchpanel
                  {...this.props}
                  panelWithMoreButton={{ borderBottom: 0 }}
                  entityTitle={this.trans('launchpanel-charge-title')}
                  actionsList={
                    <List component="div" disablePadding>
                      {!this.state.charge?.isFullyPaid() && (
                        <ListItem
                          button
                          key={`pay_this_charge`}
                          alignItems="flex-start"
                          onClick={() => {
                            if (
                              this.checkProcessIsBusy({
                                action: 'link',
                                entityName: 'charge',
                                entity: this.state.charge,
                              })
                            ) {
                              this.openIsBusyPopup();
                              this.setState({ anchorElCharge: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorElCharge: null,
                                openLeavePrompt: true,
                              });
                            } else {
                              this.setState({
                                isPayChargePopupOpen: true,
                                payChargeProcess: true,
                                anchorElCharge: null,
                              });
                            }
                          }}
                          style={{ padding: '1px 16px' }}
                        >
                          <ListItemIcon>
                            <div className="icon icon-style-launch-panel icon-ic-pay"></div>
                          </ListItemIcon>
                          <ListItemText
                            primary={this.trans('launch-panel-pay-charge')}
                            secondary={this.trans(
                              'hint/launch-panel-pay-charge'
                            )}
                          />
                        </ListItem>
                      )}

                      {this.state.charge?.isCreditType && (
                        <ListItem
                          button
                          key={`undo_credit`}
                          alignItems="flex-start"
                          onClick={() => {
                            if (
                              this.checkProcessIsBusy({
                                action: 'unrefund',
                                entityName: 'charge',
                                entity: this.state.charge,
                              })
                            ) {
                              this.openIsBusyPopup();
                              this.setState({ anchorElCharge: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorElCharge: null,
                                openLeavePrompt: true,
                              });
                            } else {
                              this.setState({
                                isUndoCreditPopupOpen: true,
                                anchorElCharge: null,
                              });
                            }
                          }}
                          style={{ padding: '1px 16px' }}
                        >
                          <ListItemIcon>
                            <div className="icon icon-style-launch-panel icon-ic-charge"></div>
                          </ListItemIcon>
                          <ListItemText
                            primary={this.trans('menuitem-undo-credit-charge')}
                            secondary={this.trans(
                              'hint/menuitem-undo-credit-charge'
                            )}
                          />
                        </ListItem>
                      )}

                      {this.state.charge?.isReferencedToSavings && (
                        <ListItem
                          button
                          key={`unsettle_from_savings`}
                          alignItems="flex-start"
                          onClick={() => {
                            if (this.checkProcessIsBusy({
                              action: 'remove',
                              entityName: 'charge',
                              entity: this.state.charge,
                            })) {
                              this.openIsBusyPopup();
                              this.setState({ anchorElCharge: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorElCharge: null,
                                openLeavePrompt: true,
                              });
                            } else {
                              this.setState({
                                isUndoSavingsPopupOpen: true,
                                anchorElCharge: null,
                              });
                            }
                          }}
                          style={{ padding: '1px 16px' }}
                        >
                          <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-remove"></div></ListItemIcon>
                          <ListItemText primary={this.trans('menuitem-undo-settle-charge-with-savings')} secondary={this.trans('hint/menuitem-undo-settle-charge-with-savings')} />
                        </ListItem>
                      )}

                      {this.state.charge?.hasSavingsWithdrawalType && !this.state.charge?.isPartOfASettlementWithSavings && (
                        <ListItem
                          button
                          key={`undo_withdrawal`}
                          alignItems="flex-start"
                          onClick={() => {
                            if (
                              this.checkProcessIsBusy({
                                action: 'refund',
                                entityName: 'charge',
                                entity: this.state.charge,
                              })
                            ) {
                              this.openIsBusyPopup();
                              this.setState({ anchorElCharge: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorElCharge: null,
                                openLeavePrompt: true,
                              });
                            } else {
                              this.setState({
                                isUndoWithdrawalPopupOpen: true,
                                anchorElCharge: null,
                              });
                            }
                          }}
                          style={{ padding: '1px 16px' }}
                        >
                          <ListItemIcon>
                            <div className="icon icon-style-launch-panel icon-ic-charge"></div>
                          </ListItemIcon>
                          <ListItemText
                            primary={this.trans(
                              'menuitem-undo-savings-withdrawal'
                            )}
                            secondary={this.trans(
                              'hint/menuitem-undo-savings-withdrawal'
                            )}
                          />
                        </ListItem>
                      )}


                      {this.state.charge?.isDeposit && (
                        <ListItem
                          button
                          key={`undo_deposit`}
                          alignItems="flex-start"
                          onClick={() => {
                            if (
                              this.checkProcessIsBusy({
                                action: 'refund',
                                entityName: 'charge',
                                entity: this.state.charge,
                              })
                            ) {
                              this.openIsBusyPopup();
                              this.setState({ anchorElCharge: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorElCharge: null,
                                openLeavePrompt: true,
                              });
                            } else {
                              this.setState({
                                isUndoDepositPopupOpen: true,
                                anchorElCharge: null,
                              });
                            }
                          }}
                          style={{ padding: '1px 16px' }}
                        >
                          <ListItemIcon>
                            <div className="icon icon-style-launch-panel icon-ic-charge"></div>
                          </ListItemIcon>
                          <ListItemText
                            primary={this.trans('menuitem-undo-savings-deposit')}
                            secondary={this.trans('hint/menuitem-undo-savings-deposit')}
                          />
                        </ListItem>
                      )}



                      {this.state.charge?.isPaidDirectlyToOwner && (
                        <ListItem
                          button
                          key={`undo_directlyPaid`}
                          alignItems="flex-start"
                          onClick={() => {
                            this.setState(
                              {
                                paymentToDelete: payment,
                              },
                              () => {
                                this.undoPaidToOwner();
                              }
                            );
                          }}
                          style={{ padding: '1px 16px' }}
                        >
                          <ListItemIcon>
                            <div className="icon icon-style-launch-panel icon-ic-charge"></div>
                          </ListItemIcon>
                          <ListItemText
                            primary={this.trans(
                              'menuitem-undo-paid-directly-to-owner'
                            )}
                            secondary={this.trans(
                              'hint/menuitem-undo-paid-directly-to-owner'
                            )}
                          />
                        </ListItem>
                      )}

                      {(this.state.charge?.isReceivable ||
                        (this.state.charge?.isPayable &&
                          this.state.charge?.isCreditType &&
                          this.state.charge?.isInvoice)) && (
                        <ListItem
                          button
                          key={`create_pdf`}
                          alignItems="flex-start"
                          onClick={() => {
                            if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorElCharge: null,
                                openLeavePrompt: true,
                              });
                            } else {
                              this.setState({
                                isCreatePdfPopupOpen: true,
                              });
                            }
                          }}
                          style={{ padding: '1px 16px' }}
                        >
                          <ListItemIcon>
                            <div className="icon icon-style-launch-panel icon-ic-file-pdf"></div>
                          </ListItemIcon>
                          <ListItemText
                            primary={this.trans('launch-panel-create-pdf')}
                            secondary={this.trans(
                              'launch-panel-create-pdf-hint'
                            )}
                          />
                        </ListItem>
                      )}

                      {(this.state.charge?.isReceivable ||
                        (!this.state.charge?.isCreditType &&
                          !this.state.charge?.isInvoice)) &&
                        this.state.charge?.chargeClass?.label !== 'Payable' &&
                        !isLocked && (
                          <ListItem
                            button
                            key={`create_invoice`}
                            alignItems="flex-start"
                            onClick={() => {
                              if (this.state.hasModifiedData) {
                                this.setState({
                                  isErrorLaunchPanelOpen: true,
                                  anchorElCharge: null,
                                  openLeavePrompt: true,
                                });
                              } else {
                                this.setState({
                                  isSetInvoicePopupOpen: true,
                                });
                              }
                            }}
                            style={{ padding: '1px 16px' }}
                          >
                            <ListItemIcon>
                              <div className="icon icon-style-launch-panel icon-ic-file-pdf"></div>
                            </ListItemIcon>
                            <ListItemText
                              primary={this.trans(
                                'launch-panel-create-invoice'
                              )}
                              secondary={this.trans(
                                'launch-panel-create-invoice-hint'
                              )}
                            />
                          </ListItem>
                        )}

                      <ListItem
                        button
                        key={`send_invoice_email`}
                        alignItems="flex-start"
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorElCharge: null,
                              openLeavePrompt: true,
                            });
                          } else {
                            this.setState(
                              {
                                hasModifiedData: false,
                                anchorElCharge: null,
                              },
                              () => {
                                this.createInvoicePdf('chargeDetails', () =>
                                  this.redirect(
                                    `/app/email/send/charge/${
                                      this.state.charge && this.state.charge.id
                                    }`
                                  )
                                );
                              }
                            );
                          }
                        }}
                        style={{ padding: '1px 16px' }}
                      >
                        <ListItemIcon>
                          <div className="icon icon-style-launch-panel icon-ic-email"></div>
                        </ListItemIcon>
                        <ListItemText
                          primary={this.trans(
                            'page/invoiceupdate-link/sendinvoice'
                          )}
                          secondary={this.trans(
                            'page/invoiceupdate-link/sendinvoice-hint'
                          )}
                        />
                      </ListItem>

                      {this.state.charge?.isReceivable &&
                        !this.state.charge?.isFullyPaid() && (
                          <ListItem
                            button
                            key={`send_email_reminder`}
                            alignItems="flex-start"
                            onClick={() => {
                              if (this.state.hasModifiedData) {
                                this.setState({
                                  isErrorLaunchPanelOpen: true,
                                  anchorElCharge: null,
                                  openLeavePrompt: true,
                                });
                              } else {
                                this.createInvoicePdf(
                                  'chargeCreateInvoice',
                                  () =>
                                    this.redirect(
                                      `/app/email/send/charge/${
                                        this.state.charge &&
                                        this.state.charge.id
                                      }?reminder=true`
                                    )
                                );
                              }
                            }}
                            style={{ padding: '1px 16px' }}
                          >
                            <ListItemIcon>
                              <div className="icon icon-style-launch-panel icon-ic-email"></div>
                            </ListItemIcon>
                            <ListItemText
                              primary={this.trans(
                                'page/chargeupdate-link/sendreminder'
                              )}
                              secondary={this.trans(
                                'page/chargeupdate-link/sendreminder-hint'
                              )}
                            />
                          </ListItem>
                        )}

                      {/* <ListItem
                          button
                          key={`add-task-btn`}
                          onClick={() => {
                            if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorElCharge: null,
                                openLeavePrompt: true
                              })
                            } else {
                              this.setState({
                                isNewTaskPopupOpen: true,
                                anchorElCharge: null
                              })
                            }
                          }}
                          style={{ padding: "1px 16px" }}
                        >
                          <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-task"></div></ListItemIcon>
                          <ListItemText primary={this.trans("charge-details/menuitem-create-task")} />
                        </ListItem> */}

                      <ListItem
                        button
                        key={`add-memo-btn`}
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorElCharge: null,
                              openLeavePrompt: true,
                            });
                          } else {
                            this.openMemoPopup(this.state.charge);
                          }
                        }}
                        style={{ padding: '1px 16px' }}
                      >
                        <ListItemIcon>
                          <div
                            className={`icon icon-style-launch-panel ${
                              this.state.charge?.hasMemos
                                ? 'icon-ic-bookmark blue-onhover'
                                : 'icon-ic-memo'
                            }`}
                          ></div>
                        </ListItemIcon>
                        <ListItemText
                          primary={this.trans(
                            'charge-details/menuitem-open-memo'
                          )}
                        />
                      </ListItem>

                      {this.state.showAllFields && (
                        <>
                          {
                            // type!=payout,  counterparty!=owner,  object=owner
                            ((!this.state.charge?.hasPayoutType &&
                              this.state.charge?.counterparty !==
                                this.state.charge?.ownerId &&
                              this.state.charge?.relatedEntity) ||
                              // type=payout,  counterparty=owner,  object=owner
                              (this.state.charge?.hasPayoutType &&
                                this.state.charge?.counterparty instanceof
                                  Company &&
                                this.state.charge?.relatedEntity instanceof
                                  Company) ||
                              //type!=payout, counterparty!=agency, object=agency
                              (!this.state.charge?.hasPayoutType &&
                                this.state.charge?.counterparty?.id !==
                                  this.getAgency()?.id &&
                                this.state.charge?.relatedEntity?.id ===
                                  this.getAgency()?.id) ||
                              // type!=payout, counterparty=agency, object=agency
                              (!this.state.charge?.hasPayoutType &&
                                this.state.charge?.counterparty?.id ===
                                  this.getAgency()?.id &&
                                this.state.charge?.relatedEntity?.id ===
                                  this.getAgency()?.id)) &&
                              !this.state.charge?.isCreditType && (
                                <ListItem
                                  button
                                  key={'create_credit_charge_coach'}
                                  alignItems="flex-start"
                                  onClick={() => {
                                    if (
                                      this.checkProcessIsBusy({
                                        action: 'settle',
                                        entityName: 'charge',
                                        entity: this.state.charge,
                                      })
                                    ) {
                                      this.openIsBusyPopup();
                                      this.setState({ anchorPaymentEl: null });
                                    } else if (this.state.hasModifiedData) {
                                      this.setState({
                                        isErrorLaunchPanelOpen: true,
                                        anchorPaymentEl: null,
                                        openLeavePrompt: true,
                                      });
                                    } else {
                                      this.setState({
                                        isCoachCreateCreditInvoiceOpen: true,
                                        anchorPaymentEl: null,
                                      });
                                    }
                                  }}
                                  style={{ padding: '1px 16px' }}
                                >
                                  <ListItemIcon>
                                    <div className="icon icon-style-launch-panel icon-ic-charge"></div>
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={this.trans(
                                      'menuitem-create-credit-charge-for-receivable'
                                    )}
                                    secondary={this.trans(
                                      'hint/menuitem-create-credit-charge-for-receivable'
                                    )}
                                  />
                                </ListItem>
                              )
                          }

                          {!this.state.charge?.isFullyPaid() && (
                            <ListItem
                              button
                              key={`settle_this_charge`}
                              alignItems="flex-start"
                              onClick={() => {
                                if (
                                  this.checkProcessIsBusy({
                                    action: 'settle',
                                    entityName: 'charge',
                                    entity: this.state.charge,
                                  })
                                ) {
                                  this.openIsBusyPopup();
                                  this.setState({ anchorElCharge: null });
                                } else if (this.state.hasModifiedData) {
                                  this.setState({
                                    isErrorLaunchPanelOpen: true,
                                    anchorElCharge: null,
                                    openLeavePrompt: true,
                                  });
                                } else {
                                  this.fetchExistingCharges();

                                  this.setState({
                                    isCoachSettleChargeOpen: true,
                                    anchorElCharge: null,
                                  });
                                }
                              }}
                              style={{ padding: '1px 16px' }}
                            >
                              <ListItemIcon>
                                <div className="icon icon-style-launch-panel icon-ic-settle-1"></div>
                              </ListItemIcon>
                              <ListItemText
                                primary={this.trans(
                                  'launch-panel-settle-charge'
                                )}
                                secondary={this.trans(
                                  'hint/launch-panel-settle-charge'
                                )}
                              />
                            </ListItem>
                          )}

                          {!this.state.charge?.isReferencedToSavings &&
                            // CASA-10008
                            (this.state.charge?.isPayable ||
                              (this.state.charge?.isReceivable &&
                                (this.state.charge?.company?.isOwner ||
                                  this.state.charge?.company?.isAgency))) &&
                            // CASA-10327
                            !(
                              this.state.charge?.isFullyPaid() &&
                              (this.state.charge?.company?.isOwner ||
                                this.state.charge?.company?.isAgency)
                            ) && (
                              <ListItem
                                button
                                key={'settle_with_savings'}
                                alignItems="flex-start"
                                onClick={() => {
                                  if (
                                    this.checkProcessIsBusy({
                                      action: 'link',
                                      entityName: 'charge',
                                      entity: this.state.charge,
                                    })
                                  ) {
                                    this.openIsBusyPopup();
                                    this.setState({ anchorElCharge: null });
                                  } else if (this.state.hasModifiedData) {
                                    this.setState({
                                      isErrorLaunchPanelOpen: true,
                                      anchorElCharge: null,
                                      openLeavePrompt: true,
                                    });
                                  } else {
                                    this.setState(
                                      {
                                        anchorElCharge: null,
                                      },
                                      () => {
                                        // this.settleWithSavingsCheckScenario();
                                        this.checkSavingsBeforeSettling()
                                      }
                                    );
                                  }
                                }}
                                style={{ padding: '1px 16px' }}
                              >
                                <ListItemIcon>
                                  <div className="icon icon-style-launch-panel icon-ic-savings"></div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={this.trans(
                                    'menuitem-settlechargewithsavings'
                                  )}
                                  secondary={this.trans(
                                    'hint/menuitem-settlechargewithsavings'
                                  )}
                                />
                              </ListItem>
                            )}

                          {!this.state.charge?.isFullyPaid() &&
                            this.state.charge?.isReceivable && (
                              <ListItem
                                button
                                key={'refund-payment'}
                                alignItems="flex-start"
                                onClick={() => {
                                  if (
                                    this.checkProcessIsBusy({
                                      action: 'settle',
                                      entityName: 'charge',
                                      entity: this.state.charge,
                                    })
                                  ) {
                                    this.openIsBusyPopup();
                                    this.setState({ anchorPaymentEl: null });
                                  } else if (this.state.hasModifiedData) {
                                    this.setState({
                                      isErrorLaunchPanelOpen: true,
                                      anchorPaymentEl: null,
                                      openLeavePrompt: true,
                                    });
                                  } else {
                                    this.setState({
                                      isSetPaidDirectlyToOwnerPopupOpen: true,
                                      anchorPaymentEl: null,
                                    });
                                  }
                                }}
                                style={{ padding: '1px 16px' }}
                              >
                                <ListItemIcon>
                                  <div className="icon icon-style-launch-panel icon-ic-pay"></div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={this.trans(
                                    'menuitem-set-charge-paid-to-owner'
                                  )}
                                  secondary={this.trans(
                                    'hint/menuitem-set-charge-paid-to-owner'
                                  )}
                                />
                              </ListItem>
                            )}

                          <ListItem
                            button
                            key="menuitem-remove"
                            onClick={() => {
                              if (
                                this.checkProcessIsBusy({
                                  action: 'remove',
                                  entityName: 'charge',
                                  entity: this.state.charge,
                                })
                              ) {
                                this.openIsBusyPopup();
                                this.setState({ anchorElCharge: null });
                              } else {
                                this.setState({
                                  isChargeRemovePopupOpen: true,
                                  anchorElCharge: null,
                                });
                              }
                            }}
                            style={{ padding: '1px 16px' }}
                          >
                            <ListItemIcon>
                              <div className="icon icon-style-launch-panel icon-ic-remove"></div>
                            </ListItemIcon>
                            <ListItemText>
                              {this.trans('menuitem-delete-charge')}
                            </ListItemText>
                          </ListItem>
                        </>
                      )}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          backgroundColor: '#e6e6e6',
                          padding: '6px 0',
                          marginTop: '8px',
                        }}
                        onClick={() =>
                          this.setState({
                            showAllFields: !this.state.showAllFields,
                          })
                        }
                      >
                        {this.state.showAllFields ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )}
                        <div>
                          {this.state.showAllFields
                            ? this.trans('title-less').toUpperCase()
                            : this.trans('title-more').toUpperCase()}
                        </div>
                      </div>
                    </List>
                  }
                />
              )}

              {this.isBeta() && (
                <Timeline
                  {...this.props}
                  relations={{
                    propertyId:
                      this.state.charge && this.state.charge.propertyId,
                    unitId: this.state.charge && this.state.charge.unitId,
                    contractId:
                      this.state.charge && this.state.charge.contractId,
                    chargeId: this.state.charge && this.state.charge.id,
                    companyId: this.state.charge && this.state.charge.companyId,
                    refersToEventId:
                      this.state.charge && this.state.charge.eventId,
                  }}
                  entityEvents={this.state.events}
                  fetchEntityEvents={this.fetchEntityEvents.bind(
                    this,
                    this.state.charge && this.state.charge.id
                  )}
                  fetchingEvents={this.state.fetchingEvents}
                  charge={this.state.charge}
                />
              )}
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans('memo')}
          content={
            <div>
              <Memo
                {...this.props}
                relations={{ chargeId: this.state.chargeToAddNote?.id }}
                entity={this.state.chargeToAddNote}
                saveDraft={this.saveDraft}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans('button-close')}
          onSave={() => this.saveReminder(this.state.chargeToAddNote)}
          hideCross={true}
          subtitle={
            this.state.chargeToAddNote && this.state.chargeToAddNote.displayName
              ? this.state.chargeToAddNote.displayName
              : ''
          }
        />

        <QuickPaymentDialog
          {...this.props}
          charge={this.state.charge}
          isOpen={this.state.isPayChargePopupOpen}
          initializePage={() => {
            this.setState(
              {
                hasModifiedData: false,
                additionalSectionHasModifiedData: false,
              },
              () => {
                this.initializePage(this.state.charge?.id);
              }
            );
          }}
          closeDialog={() => {
            this.setState({
              isPayChargePopupOpen: false,
              isSaving: false,
              anchorEl: null,
            });
          }}
        />

        <PromptDialog
          {...this.props}
          title={this.trans('dialog/attention-title') + '!'}
          content={
            <div>
              <span>{this.trans('title-remove-savings-payment-warning')}</span>
            </div>
          }
          openLeavePrompt={this.state.cannotDeleteSavingsChargeDialog}
          positiveButtonLabel={this.trans('button-close')}
          onSave={() =>
            this.setState({ cannotDeleteSavingsChargeDialog: false })
          }
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans('dialog/bankaccount-title')}
          content={
            <BankAccountCreate
              {...this.props}
              onSave={this.addBankAccount}
              onClose={() =>
                this.setState({ isCreateBankAccountPopupOpen: false })
              }
            />
          }
          openLeavePrompt={this.state.isCreateBankAccountPopupOpen}
          onClose={() => {
            this.setState({ isCreateBankAccountPopupOpen: false });
            this.props.dispatch({
              type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_CLEAR,
            });
          }}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isPostProcessWithdrawalDialogOpen}
          title={this.trans('dialog/attention-title') + '!'}
          content={this.trans(
            'dialog/postprocess-info/withdrawalforpayablecharge'
          )}
          positiveButtonLabel={this.trans('dialog-button/close')}
          onlyPositiveButton={true}
          onSave={() => {
            this.setState(
              { isPostProcessWithdrawalDialogOpen: false },
              this.redirectBack
            );
          }}
        />

        <PromptDialog
          {...this.props}
          title={this.trans('dialog/extrapayment-title')}
          content={
            <div>
              <p>
                {this.trans(
                  'dialog/extrapayment-info/createextrapayment',
                  this.state.detailsForExtraPaymentPopup
                )}
              </p>
              <p>{this.trans('dialog/extrapayment-info/buttonskip')}</p>
            </div>
          }
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          positiveButtonLabel={this.trans(
            'dialog/extrapayment-button/createextrapayment'
          )}
          openLeavePrompt={this.state.createExtraPaymentPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({ createExtraPaymentPopupOpen: false });
          }}
          onSave={() =>
            this.setState(
              {
                createExtraPaymentPopupOpen: false,
                shouldCreateExtraPayment: true,
              },
              this.save
            )
          }
          additionalBtns={[
            <Button
              key="dialog-additional-btn"
              color="primary"
              onClick={() =>
                this.setState(
                  {
                    createExtraPaymentPopupOpen: false,
                    shouldCreateExtraPayment: false,
                    skipCreateExtraPayment: true,
                  },
                  this.save
                )
              }
            >
              {this.trans('dialog-button/skip')}
            </Button>,
            <Button
              variant="contained"
              key="dialog-additional-btn"
              color="primary"
              onClick={() =>
                this.setState(
                  {
                    createExtraPaymentPopupOpen: false,
                    shouldCreateExtraPayment: true,
                    shouldSettleTheDifference: true,
                  },
                  this.save
                )
              }
            >
              {this.trans('dialog/extrapayment-button/settlethedifference')}
            </Button>,
          ]}
        />

        <PromptDialog
          {...this.props}
          title={this.trans('dialog/extracharge-title')}
          content={
            <div>
              <p>
                {
                  this.state.detailsForAdditionalChargePopup
                    .additionalChargeInformationText
                }
              </p>
              <p>{this.trans('dialog/extracharge-info/buttonskip')}</p>
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={
            this.state.additionalChargePopupOpen &&
            !this.state.isChargeFullyPaid
          }
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          positiveButtonLabel={
            !this.state.isChargeFullyPaid
              ? this.trans('dialog/extracharge-button/createextracharge')
              : null
          }
          onDiscard={() => this.setState({ additionalChargePopupOpen: false })}
          onSave={() =>
            this.setState(
              {
                additionalChargePopupOpen: false,
                shouldCreateAdditionalCharge: true,
              },
              this.save
            )
          }
          additionalBtns={[
            <Button
              key="dialog-additional-btn"
              color="primary"
              onClick={() =>
                this.setState(
                  {
                    additionalChargePopupOpen: false,
                    shouldCreateAdditionalCharge: false,
                    skipCreateAdditionalCharge: true,
                  },
                  this.save
                )
              }
            >
              {this.trans('dialog-button/skip')}
            </Button>,
            <Button
              variant="contained"
              key="dialog-additional-btn"
              color="primary"
              onClick={() =>
                this.setState(
                  {
                    createExtraPaymentPopupOpen: false,
                    shouldCreateAdditionalCharge: true,
                    shouldSettleTheDifference: true,
                  },
                  this.save
                )
              }
            >
              {this.trans('dialog/extracharge-button/settlethedifference')}
            </Button>,
          ]}
        />

        <SettleWithSavingsDialog
          {...this.props}
          entity={this.state.charge}
          isOpen={this.state.isChargeSettleWithSavingsPopupOpen}
          settleSavingScenarioMessage={this.state.settleSavingScenarioMessage}
          initializePage={() => {
            this.initializePage(this.state.charge?.id);
          }}
          closeDialog={() =>
            this.setState({ isChargeSettleWithSavingsPopupOpen: false })
          }
        />

        <UndoSettleWithSavingsDialog
          {...this.props}
          entity={this.state.charge}
          isOpen={this.state.isUndoSavingsPopupOpen}
          initializePage={() => {
            this.initializePage(this.state.charge?.id);
          }}
          closeDialog={() =>
            this.setState({
              isUndoSavingsPopupOpen: false,
              anchorElCharge: null,
            })
          }
        />

        <CreateTaskDialog
          {...this.props}
          entity={this.state.charge}
          isOpen={this.state.isNewTaskPopupOpen}
          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false,
              anchorElCharge: null,
            });
          }}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'charge-unsettle-from-charge-page-content-dialog'}
          isOpen={this.state.isChargeUnSettlePopupOpen}
          onCancel={() => {
            this.setState({
              isChargeUnSettlePopupOpen: false,
            });
          }}
          onDelete={this.unSettle}
          type="button-unsettle"
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'page/chargeupdate-dialog/preprocess-info/unlinkpayment'}
          isOpen={this.state.isPaymentUnlinkPopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.unlinkPayment}
          type="button-unlink"
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'page/chargeupdate-dialog/preprocess-info/removepayment'}
          isOpen={this.state.isPaymentRemovePopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'charge-unlink-info'}
          isOpen={this.state.isMainChargeUnlinkPopupOpen}
          onCancel={() => {
            this.setState({
              isMainChargeUnlinkPopupOpen: false,
            });
          }}
          onDelete={this.unlinkCharge}
          type={'button-continue'}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'title-charge-delete-from-charge-page-content-dialog'}
          isOpen={this.state.isChargeRemovePopupOpen}
          onCancel={() => {
            this.setState({
              isChargeRemovePopupOpen: false,
            });
          }}
          onDelete={this.deleteCharge}
        />

        <DeleteEntityPrompt
          {...this.props}
          title={this.trans('page/chargeupdate-preprocess/unrefund-title')}
          entityName={'page/chargeupdate-preprocess/unrefund-info'}
          isOpen={this.state.isChargeUnrefundPopupOpen}
          onCancel={() => {
            this.setState({
              isChargeUnrefundPopupOpen: false,
            });
          }}
          onDelete={this.unrefundCharge}
          type={'page/chargeupdate-preprocess/unrefund-button'}
        />

        <DeleteEntityPrompt
          {...this.props}
          title={this.trans('page/chargeupdate-preprocess/undo-credit-title')}
          entityName={'page/chargeupdate-preprocess/undo-credit-info'}
          isOpen={this.state.isUndoCreditPopupOpen}
          onCancel={() => {
            this.setState({
              isUndoCreditPopupOpen: false,
            });
          }}
          onDelete={this.undoCredit}
          type={'page/chargeupdate-preprocess/undo-credit-button'}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isUndoWithdrawalPopupOpen}
          title={this.trans('page/chargeupdate-preprocess/undo-withdrawal-title')}
          content={this.trans('page/chargeupdate-preprocess/undo-withdrawal-info')}
          positiveButtonLabel={this.trans('dialog-button/continue')}
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          onSave={this.undoWithdrawal}
          onDiscard={() => { this.setState({isUndoWithdrawalPopupOpen: false,}); }}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isUndoDepositPopupOpen}
          title={this.trans('page/chargeupdate-preprocess/undo-deposit-title')}
          content={this.trans('page/chargeupdate-preprocess/undo-deposit-info')}
          positiveButtonLabel={this.trans('dialog-button/continue')}
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          onSave={this.undoDeposit}
          onDiscard={() => { this.setState({isUndoDepositPopupOpen: false,}); }}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() =>
            this.setState({ openLeavePrompt: false, nextPath: '' })
          }
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={
            this.state.isErrorLaunchPanelOpen
              ? () =>
                  this.setState({
                    openLeavePrompt: false,
                    hasModifiedData: false,
                    additionalSectionHasModifiedData: false,
                  })
              : this.leave.bind(this)
          }
          onSave={() => {
            this.setState({ openLeavePrompt: false });
            this.save();
          }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isSetPaidDirectlyToOwnerPopupOpen}
          title={this.trans('menuitem-set-charge-paid-to-owner')}
          content={
            <div>
              {this.trans('page/chargeupdate-preprocess/paidtoowner-info')}
            </div>
          }
          positiveButtonLabel={this.trans('button-create')}
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          onSave={this.setPaidDirectlyToOwner}
          onDiscard={() =>
            this.setState({ isSetPaidDirectlyToOwnerPopupOpen: false })
          }
        />

        {this.state.charge && this.state.isCoachCreateCreditInvoiceOpen && (
          <CoachCreateCreditInvoice
            {...this.props}
            step={2}
            isOpen={this.state.isCoachCreateCreditInvoiceOpen}
            charge={this.state.charge}
            initializePage={this.initializePage}
            onCloseCreateCreditInvoiceCoach={() => {
              this.setState({
                isCoachCreateCreditInvoiceOpen: false,
                isSaving: false,
              });
            }}
          />
        )}

        {this.state.charge && (
          <CoachNewSettleCharge
            {...this.props}
            isOpen={this.state.isCoachSettleChargeOpen}
            charge={this.state.charge}
            updateCharge={(newCharge) => {
              this.setState(
                {
                  settledChargeIds: [...newCharge?.settledChargeIds],
                  settledCharges: [
                    ...newCharge?.settledCharges.map(
                      (charge: ChargeInterface) => {
                        const settledCharge = ChargeFactory.create(charge);
                        return {
                          charge: settledCharge,
                        };
                      }
                    ),
                  ],
                },
                () => this.updateMainCharge(newCharge)
              );
            }}
            onCloseCoach={() => {
              this.setState({
                isCoachSettleChargeOpen: false,
                isSaving: false,
              });
            }}
          />
        )}

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isCreatePdfPopupOpen}
          title={this.trans('dialog/attention-title') + '!'}
          content={this.trans('dialog/create-pdf-title')}
          positiveButtonLabel={this.trans('dialog-button/continue')}
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          onSave={() => {
            this.createInvoicePdf('chargeDetails', () => {
              setTimeout(() => {
                this.setState({ isCreatePdfPopupOpen: false, isSaving: false });
              }, 0);
            });
          }}
          onDiscard={() => this.setState({ isCreatePdfPopupOpen: false })}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isSetInvoicePopupOpen}
          title={this.trans('dialog/attention-title') + '!'}
          content={this.trans('dialog/set-invoice-title')}
          positiveButtonLabel={this.trans('dialog-button/continue')}
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          onSave={() => {
            this.createInvoicePdf('chargeInvoice', () => {
              setTimeout(() => {
                this.setState({
                  isSetInvoicePopupOpen: false,
                  isSaving: false,
                });
              }, 0);
            });
          }}
          onDiscard={() => this.setState({ isSetInvoicePopupOpen: false })}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isNegativeAmountPopupOpen}
          title = {this.trans("dialog/warning-title")}
          content = { 
            <div> <p> { 
              this.trans(
                "dialog/preprocess-negativesavingsaccount/info", 
                { savingsAmount: this.formatter.formatNumber(this.getSavingsAmount(), this.state.charge?.currency) }
              )
            }
            </p> </div> 
          }
          positiveButtonLabel={this.trans("dialog-button/close")}
          onlyPositiveButton={true}
          onSave={ () => { 
              this.setState( 
                { isNegativeAmountPopupOpen: false, },
              ); 
            } 
          }
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    charges: state.charges,
    payments: state.payments,
    component: state.chargeUpdate,
    globalTypes: state.globalTypes,
  };
};

export default connect(mapStateToProps)(ChargeUpdate);